import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import AuthHeader from "../../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../../UI/AuthSideMenu/AuthSideMenu";
import { SuccessFailureModal, PlainModalOverlay, Modal } from "../../UI/Modal/Modal";
import UpgradePopup from '../../UI/SubscriptionPlans/UpgradePopup';
import { GoAlert } from "react-icons/go";
import { RiCalendarScheduleLine } from "react-icons/ri";


import Feedback from "../../Dashboard/Feedback";
import {
    checkAuthenticatedUser,
    getOrdinalDate,
    copyText
} from "../../../utils/client-functions";
import { setFetching, setUserFirstName, setProfileImg, setResumeSubDuration, setIsResumeSubbed, setResumeServicesNumbers } from "../../../redux/states";
import { useErrorSetter, useSuccessSetter, useInfoSetter } from '../../../hooks/useUiMessages';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import ResumePricing from "../../Pricing/ResumePricing";
import { TypeAnimation } from 'react-type-animation';
import { FaLongArrowAltRight } from "react-icons/fa";
import { TbReplaceFilled } from "react-icons/tb";
import { FaMapLocationDot } from "react-icons/fa6";
import { ImBriefcase } from "react-icons/im";
import { TbLinkPlus } from "react-icons/tb";
import axios from "axios";
import holisticAnalytics from '../../../utils/holisticAnalytics';
import { useConfirm } from 'material-ui-confirm';

import { downloadResumeDirect, downloadCoverLetterDirect } from '../../../utils/downloadResumeDirect';

//MODAL IMPORTS
import MainModal from "../../UI/Modal/MainModal";
import InternalAppJobModal from "./InternalAppJobModal";
import FieldAnswersModal from "./FieldAnswersModal";
import ResumeSelectorModal from "./ResumeSelectorModal";
import ResumePreviewModal from "../ResumePreviewModal";
import QnAModal from "./QnAModal";
import JobConnection from "../../UI/JobConnection/JobConnection";
import ProcessingQueueView from "../../UI/JobConnection/ProcessingQueueView";
import {AssistSectionStyled, NoConnectionViewStyled} from "../../../styled/JobConnection";
import Button from "../../UI/Buttons/Button";
import { ButtonSubmitGreen } from "../../UI/Buttons/Buttons";
import TutorialPopover from '../../UI/TutorialPopover/TutorialPopover';
import { getTutorialTipMeta } from '../../../utils/tutorialApi';
import { ButtonThin } from "../../UI/Buttons/Buttons";
import styled from "styled-components";
import bubblebg from "../../../images/bubblebannerbg.png"
import bubblesvg from "../../../images/Bubble.svg";
import BubbleFloat from "../../UI/BubbleFloat/BubbleFloat";
import {FiAlertCircle} from "react-icons/fi";
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import InputHandler from "../Tools/InputHandler";
import AuthInput from '../../UI/Input/AuthInputs';
import { FaLongArrowAltLeft } from "react-icons/fa";
import OvalSpinner from "../../UI/Spinners/OvalSpinner";
import { MdOutlineOpenInFull, MdStopCircle, MdDeleteForever } from 'react-icons/md';
import { SiGmail } from 'react-icons/si';
import ResumeSelectList from "../ResumeSelectList";

const TypeWrite = styled.div`
    width: auto;
    margin-top: 4rem;
    font-size: .85rem;
    text-align: center;
    font-weight: 600;
    color: #fff;
    border-radius: 20px;
    padding: 15px 10px;
    background:
            linear-gradient(to right, rgba(111, 203, 209, 0.4), rgba(57, 104, 107, 0.8)),
            url(${bubblebg}) center center;
    background-size: cover;

`
 

const JobHub = () => {
    const { 
        resumeSubDuration, 
        isResumeSubbed,
        user,
        resumeServicesNumbers 
    } = useSelector((state) => state.stateData);
    const location = useLocation();


    const [jobs, setJobs] = useState([]);
    const [textColor, setTextColor] = useState('black'); // consumed by TypeAnimation side-effects
    const [allResumes, setAllResumes] = useState([]);
    const [singleResume, setSingleResume] = useState({});
    const [chosenJob, setChosenJob] = useState({});
    const [actionString, setActionString] = useState('');
    const [activeResIndex, setActiveResIndex] = useState(0);
    const [isFeedbackTime, setIsFeedbackTime] = useState(false);
    const [pricingOpened, setPricingOpened] = useState(false);
    const [authMenuOpen, setAuthMenuOpen] = useState(false);
    const [linkedinUrl, setLinkedinUrl] = useState("");
    const [companyUrl, setCompanyUrl] = useState("");
    const [applicants, setApplicants] = useState("");
    const [successfulAchievement, openSuccessfulAchievement] = useState(false);
    const [isFirstFreeUsed, setIsFirstFreeUsed] = useState(false);
    const [addJobUrl, setAddJobUrl] = useState('');
    
 
    // touch these variables once to avoid unused warnings in strict lint configs
    const [loadingJobs, setLoadingJobs] = useState(false);
    const [skipCount, setSkipCount] = useState(0);
    const [hasMoreJobs, setHasMoreJobs] = useState(true);
    const [loading, setLoading] = useState(false);
    const [crawlLoader, setCrawlLoader] = useState(false);
    const [crawlMessage, setCrawlMessage] = useState('Searching for 90%+ Interview Job matches...');

    // Auto-Apply intro modal and schedule state
    const [showAutoApplyIntroModal, setShowAutoApplyIntroModal] = useState(false);
    const [autoApplyModalView, setAutoApplyModalView] = useState('intro'); // 'intro' | 'schedule'
    // Modal shown right after adding an external job to offer immediate auto-apply
    const [showApplyAfterAddModal, setShowApplyAfterAddModal] = useState(false);
    const [addedJobForApply, setAddedJobForApply] = useState(null);
    const [scheduleFrequency, setScheduleFrequency] = useState('Daily');
    const [scheduleTime, setScheduleTime] = useState('09:00');
    const [scheduleCountry, setScheduleCountry] = useState(user?.country || '');
    const [scheduleMaxJobs, setScheduleMaxJobs] = useState(5);
    const [scheduleEnableColdIntro, setScheduleEnableColdIntro] = useState(false);
    const scheduleFrequencyOptions = [ { name: 'Daily' }, { name: 'Weekly' } ];
    const scheduleMaxJobsOptions = Array.from({ length: 10 }, (_, i) => ({ name: String(i + 1), value: String(i + 1) }));
    const [existingSchedule, setExistingSchedule] = useState(null);
    const [scheduleCardLoading, setScheduleCardLoading] = useState(false);
    const [scheduleCtaLoading, setScheduleCtaLoading] = useState(false);
    const [scheduleSaveLoading, setScheduleSaveLoading] = useState(false);
    const [scheduleDeleteLoading, setScheduleDeleteLoading] = useState(false);


    const [resumeSelectorModalOpen, setResumeSelectorModalOpen] = useState(false);
    const [showInternalAppJobModal, setShowInternalAppJobModal] = useState(false);
    const [showAddJobModal, setShowAddJobModal] = useState(false);
    const [addJobCompany, setAddJobCompany] = useState('');
    const [addingJob, setAddingJob] = useState(false);
    const [addingJobMessage, setAddingJobMessage] = useState('Adding job… extracting details');
    // Track the in-flight external job add operation
    const pendingAddRef = useRef(null); // holds requestId returned by server
    const addJobTimeoutRef = useRef(null); // safety timeout id
    const lastAddUrlRef = useRef(null); // normalized URL for current add

    // Normalize URLs for robust matching between SSE payloads and the URL we queued
    const normalizeUrlForMatch = useCallback((u) => {
        if (!u) return '';
        try {
            const parsed = new URL(u);
            // remove trailing slashes from pathname
            const path = (parsed.pathname || '').replace(/\/+$/,'');
            // lowercase hostname and path for robust matching
            return `${parsed.protocol}//${parsed.hostname.toLowerCase()}${path.toLowerCase()}`;
        } catch (_){
            return String(u).toLowerCase().replace(/\/+$/,'');
        }
    }, []);

    // Clear any pending timers on unmount
    useEffect(() => {
        return () => {
            if (addJobTimeoutRef.current) {
                try { clearTimeout(addJobTimeoutRef.current); } catch(_) {}
                addJobTimeoutRef.current = null;
            }
        };
    }, []);
    // Progress UI for company site auto apply & resume generation
    const [progressStatus, setProgressStatus] = useState('');
    const [progressPercentage, setProgressPercentage] = useState(0);
    const [showCrawlModal, setShowCrawlModal] = useState(false);
    const [crawlCountry, setCrawlCountry] = useState(user?.country || '');
    const [crawlJobConnectType, setCrawlJobConnectType] = useState('Remote');
    const [crawlState, setCrawlState] = useState(user?.stateRegion || '');
    const jobTypesArray = [
        { name: 'Remote' },
        { name: 'Hybrid' },
        { name: 'On-site' }
    ];

    // --- SEMI-AUTO APPLY STATE ---
    const [showFieldAnswersModal, setShowFieldAnswersModal] = useState(false);
    const [fieldAnswers, setFieldAnswers] = useState([]);
    const [fieldAnswersUrl, setFieldAnswersUrl] = useState('');
    const [fieldAnswersJob, setFieldAnswersJob] = useState(null);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewResume, setPreviewResume] = useState(null);

    // --- QnA Modal State for LOGIN ALGORITHM ---
    const [showQnAModal, setShowQnAModal] = useState(false);
    const [loginQnAJobDesc, setLoginQnAJobDesc] = useState('');
    const [loginQnAJobDescSaved, setLoginQnAJobDescSaved] = useState(false);
    const [loginQnAInput, setLoginQnAInput] = useState('');
    const [loginQnAList, setLoginQnAList] = useState([]); // [{question, answer}]
    const [loginQnALoading, setLoginQnALoading] = useState(false);
    const [loginQnAEditingDesc, setLoginQnAEditingDesc] = useState(false);

    const isCompanyAutoApplyTriggered = useRef(false);
    const tryAgainActiveRef = useRef(false);
    const processingMinimizedRef = useRef(false);
    // Track in-flight fetch-new-job-connects request to handle SSE race conditions
    const jobConnectPendingRef = useRef(null);

    const closeModalsAndReset = () => {
        loadJobs(0) //to reset page details
        setLinkedinUrl("");
        setCompanyUrl("");
        setAddJobUrl("");
        setFieldAnswersUrl("")
        setFieldAnswers([]);
        setActiveResIndex(0);

        setResumeSelectorModalOpen(false);
        setShowInternalAppJobModal(false);
        setShowAddJobModal(false);
        setShowFieldAnswersModal(false);
        setShowQnAModal(false);
        setLoginQnAJobDescSaved(false);
        setLoginQnALoading(false);

        setLoginQnAJobDesc('');
        setLoginQnAInput('');
        setLoginQnAList([]);
        setSingleResume({});
        setFieldAnswersJob(null)

        isCompanyAutoApplyTriggered.current = false
    }

    // --- Tutorial popovers (Job Hub) ---
    const JOBHUB_TIP_ID = 'jobhub:guide:v1';
    const createResumeRef = useRef(null);
    const jobConnectRef = useRef(null);
    const viewAppsRef = useRef(null);
    const changeLocationRef = useRef(null);
    const addExternalRef = useRef(null);
    const applyForMeRef = useRef(null);
    const [tipMeta, setTipMeta] = useState({});
    const [currentTip, setCurrentTip] = useState(0); // 0 = none, 1..6 sequence
    const [sequenceCompleted, setSequenceCompleted] = useState(false);

    // Hide tutorials when any modal or side menu is open to prevent z-index issues on mobile
    const anyOverlayOpen = authMenuOpen || showAutoApplyIntroModal || showInternalAppJobModal || 
                          showAddJobModal || showCrawlModal || showFieldAnswersModal || showQnAModal || loading;
    // track when the main initial fetch that populates the component completes
    const [initialPopulateDone, setInitialPopulateDone] = useState(false);
    const initialPopulateDoneRef = useRef(false);

    const scheduleNextTip = useCallback((from) => {
        // schedule next tip 6s later
        setTimeout(async () => {
            try {
                const meta = await getTutorialTipMeta(JOBHUB_TIP_ID);
                if (meta && meta.dontShow) return;
            } catch (_) {}
            setCurrentTip((prev) => {
                const next = (from || prev) + 1;
                if (next > 6) {
                    setSequenceCompleted(true);
                    return 0;
                }
                return next;
            });
        }, 6000);
    }, []);

    

    // load persisted meta (but defer starting the first tip until initial data fetch completes)
    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const meta = await getTutorialTipMeta(JOBHUB_TIP_ID);
                if (!mounted) return;
                setTipMeta(meta || {});
                // Do NOT start the tip here; wait for initial data population below
            } catch (e) {}
        })();
        return () => { mounted = false; };
    }, []);

    // Start the first tip approximately 10s after the main initial fetch/populate completes
    useEffect(() => {
        if (!tipMeta) return;
        if (tipMeta?.dontShow) return;
        if (!initialPopulateDone) return;

        // start countdown of ~10s then show first tip
        const id = setTimeout(() => {
            // only show if sequence not completed and not already showing
            if (!sequenceCompleted) setCurrentTip(1);
        }, 10000);
        return () => clearTimeout(id);
    }, [tipMeta, initialPopulateDone, sequenceCompleted]);

    const isEffectExecuted = useRef(false);
    const jobListRef = useRef(null);
    const isFetching = useRef(false);

    const dispatch = useDispatch();
    const confirm = useConfirm();

    const navigate = useNavigate();
    const isAuth = localStorage?.getItem("token");

    const styles = {
        list: {
            fontSize: '.85rem',
            lineHeight: '1.5',
            padding: '0 1rem 1rem 1rem',
            width: '100%',

        },
        newTabLnk: {
            color: '#3E8F93',
            textDecoration: 'dotted',
            cursor: 'pointer',
            fontSize: '.7rem',
        },
        applicants: {
            fontSize: '.75rem',
            color: 'rgba(0, 0, 0, 0.634)',
            margin: "10px auto",
            textAlign: "center",
            width: "100%"
        },
        noResumes: {
            boxSizing: 'border-box',
            color: '#333333',
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'center',
            width: '100%'
        }
    }

    // --- MULTI-APPLY MODE STATE ---
    const [multiApplyMode, setMultiApplyMode] = useState(false);
    const [selectedJobIds, setSelectedJobIds] = useState([]); // store job ids (max 5)
    // --- MULTI-APPLY PROCESS VIEW STATE ---
    const [processingActive, setProcessingActive] = useState(false);
    const [processingMinimized, setProcessingMinimized] = useState(false);
    useEffect(() => {
        processingMinimizedRef.current = processingMinimized;
    }, [processingMinimized]);
    const [processingJobs, setProcessingJobs] = useState([]); // selected job objects
    const [processingCounts, setProcessingCounts] = useState({ done: 0, total: 0 });
    const [processingBatchId, setProcessingBatchId] = useState(null); // backend batch id for auto-apply
    const [startPending, setStartPending] = useState(false);
    const [stopPending, setStopPending] = useState(false);
    const [perJobStatuses, setPerJobStatuses] = useState([]); // per selected job: queued|running|success|failed
    const [perJobStages, setPerJobStages] = useState([]); // granular stage per job (email_discovery, email_normalize, resume_optimize, cover_letter, sending_email, sent)
    // Reference perJobStages to avoid lint complaining when only the setter is used early
    useEffect(() => { /* no-op use to appease linter */ }, [perJobStages.length]);
    // Gmail integration status
    const [gmailGranted, setGmailGranted] = useState(false);
    const [gmailIsGmail, setGmailIsGmail] = useState(false);
    const [disconnectPending, setDisconnectPending] = useState(false);
    const confirmDialog = useConfirm();
    const handleDisconnectGmail = async () => {
        try {
            setDisconnectPending(true);
            await axios.post('/user/gmail/disconnect', {}, { headers: { 'x-access-token': isAuth } });
            setGmailGranted(false);
            successSetter('Gmail disconnected');
        } catch (e) {
            errorSetter('Failed to disconnect Gmail');
        } finally {
            setDisconnectPending(false);
        }
    };

    // Start multi-apply flow: now checks for Gmail permission if needed
    const [showEmailPermModal, setShowEmailPermModal] = useState(false);
    const [gmailAuthUrl, setGmailAuthUrl] = useState('');
    // const [checkingPerm, setCheckingPerm] = useState(false);
    const [emailProvider, setEmailProvider] = useState('');
    // Track which flow requested Gmail: 'multi' (select jobs now) or 'schedule' (auto-run later)
    const [gmailFlow, setGmailFlow] = useState('');
    // Track popup window and polling fallback when postMessage fails
    const gmailPopupRef = useRef(null);
    const gmailPopupCheckRef = useRef(null);
    // Allow bypassing Gmail connection and continue with internal SMTP
    const handleContinueWithoutGmail = () => {
        try { holisticAnalytics.track('ui.feature_used', { featureUsed: 'auto_apply', eventData: { action: 'continue_without_gmail' } }); } catch(_) {}
        setShowEmailPermModal(false);
        // Proceed based on flow: only start immediately in multi-apply flow
        if (gmailFlow === 'multi') {
            startProcessingWithSelected(selectedJobIds);
        } else {
            // In schedule flow, nothing starts now
            infoSetter('You can continue without Gmail connection.');
        }
    };
    // Cleanup any popup poller on unmount
    useEffect(() => {
        return () => {
            try { if (gmailPopupCheckRef.current) { clearInterval(gmailPopupCheckRef.current); gmailPopupCheckRef.current = null; } } catch(_) {}
            try { if (gmailPopupRef.current && !gmailPopupRef.current.closed) { gmailPopupRef.current.close(); } } catch(_) {}
            gmailPopupRef.current = null;
        };
    }, []);

    

    // Cache flag to avoid refetching schedule on every modal open
    const scheduleFetchedRef = useRef(false);
    // Fetch existing schedule whenever the intro modal opens
    useEffect(() => {
        if (showAutoApplyIntroModal && autoApplyModalView === 'intro' && !scheduleFetchedRef.current) {
            setScheduleCardLoading(true);
            axios.get('/user/auto-apply/schedule', { headers: { 'x-access-token': isAuth } })
                .then((resp) => {
                    const sch = resp?.data?.schedule || null;
                    setExistingSchedule(sch);
                    if (sch) {
                        // Prefill schedule form state
                        setScheduleCountry(sch.country || '');
                        setScheduleFrequency(sch.frequency || 'Daily');
                        setScheduleTime(sch.timeOfDay || '09:00');
                        setScheduleMaxJobs(Number(sch.maxJobsPerRun || 5));
                        setScheduleEnableColdIntro(sch.enableColdIntroductions || false);
                        // Select resume in list if present
                        try {
                            const ref = String(sch.resumeRef || '');
                            if (Array.isArray(allResumes) && allResumes.length) {
                                const idx = allResumes.findIndex(r => String(r.id) === ref || String(r?.storageDetails?.name) === ref);
                                if (idx >= 0) setActiveResIndex(idx + 1);
                            }
                        } catch(_){}
                    }
                })
                .catch(() => setExistingSchedule(null))
                .finally(() => { setScheduleCardLoading(false); scheduleFetchedRef.current = true; });
        }
    }, [showAutoApplyIntroModal, autoApplyModalView, isAuth, allResumes]);
    // Helper: start processing given selected job identifiers
    const startProcessingWithSelected = async (ids) => {
        const selIds = Array.isArray(ids) && ids.length ? ids : selectedJobIds;
        if (!selIds || selIds.length === 0) {
            errorSetter('Select at least one job to start.');
            return;
        }
        const selJobs = jobs.filter(j => selIds.includes(getJobIdentifier(j)));
        if (selJobs.length === 0) {
            errorSetter('Could not resolve selected jobs. Restart Process');
            return;
        }
        setProcessingJobs(selJobs);
        setProcessingCounts({ done: 0, total: selJobs.length });
        setProcessingActive(true);
        setProcessingMinimized(false);
        setMultiApplyMode(false);
        setPerJobStatuses(new Array(selJobs.length).fill('queued'));
        setPerJobStages(new Array(selJobs.length).fill('queued'));

        // Kick off backend batch processing
        try {
            const onlyIds = selJobs.map(j => j?.id).filter(Boolean);
            if (!onlyIds.length) {
                // fallback: try best-effort mapping by url/final_url against backend expectations
                errorSetter('Selected jobs are missing IDs. Refresh and try again.');
                setProcessingActive(false);
                return;
            }
            const resp = await axios.post('/user/auto-apply/start', { selectedJobIds: onlyIds }, { headers: { 'x-access-token': isAuth } });
            if (resp?.status === 202 && resp?.data?.batchId) {
                setProcessingBatchId(resp.data.batchId);
                if (typeof resp.data.total === 'number') {
                    setProcessingCounts({ done: 0, total: resp.data.total });
                }
            } else {
                errorSetter(resp?.data?.error || 'Failed to start auto-apply.');
                setProcessingActive(false);
            }
        } catch (e) {
            const resp = e?.response;
            // Handle quota exceeded for auto-apply and open pricing
            if (resp && (resp.data?.status === 'quota_exceeded' || (resp.status === 403 && resp.data?.openPricing))) {
                try { setPricingOpened(true); } catch(_) {}
                errorSetter(resp.data?.message || 'Auto-apply quota reached. Upgrade to continue.');
            } else {
                errorSetter(resp?.data?.error || 'Could not start auto-apply.');
            }
            setProcessingActive(false);
        }
    };

    const toggleMultiApplyMode = (e) => {
        try { if (e && e.preventDefault) e.preventDefault(); } catch(_) {}
        setMultiApplyMode((prev) => {
            const next = !prev;
            if (!next) setSelectedJobIds([]); // reset when turning off
            return next;
        });
    };

    // Primary CTA behavior: open intro modal when entering, toggle off when already in mode
    const handlePrimaryApplyClick = (e) => {
        try { if (e && e.preventDefault) e.preventDefault(); } catch(_) {}
        if (multiApplyMode) {
            toggleMultiApplyMode();
        } else {
            setAutoApplyModalView('intro');
            setShowAutoApplyIntroModal(true);
        }
    };

    const maxSelectable = 5;
    const getJobIdentifier = (job) => job?.id || job?.external_url || job?.url || `${job?.title || job?.job_title}-${job?.company_name || job?.company}`;
    const handleToggleJobSelect = (job) => {
        const id = getJobIdentifier(job);
        if (!id) return;
        setSelectedJobIds((prev) => {
            const exists = prev.includes(id);
            if (exists) return prev.filter((x) => x !== id);
            if (prev.length >= maxSelectable) {
                errorSetter(`You can select up to ${maxSelectable} jobs.`);
                return prev;
            }
            return [...prev, id];
        });
    };
    
    const handleStartMultiApply = async () => {
        if (!multiApplyMode) return;
        if (!selectedJobIds || selectedJobIds.length === 0) {
            errorSetter('Select at least one job to start.');
            return;
        }
        // Check if user's email is gmail and permission granted
        try {
            setStartPending(true);
            const resp = await axios.get('/user/gmail/permission-status', { headers: { 'x-access-token': isAuth }});
            const { isGmail, granted } = resp.data || {};
            setEmailProvider(isGmail ? 'gmail' : 'other');
            if (isGmail && !granted) {
                // fetch auth URL
                try {
                    const s = await axios.get('/user/gmail/oauth/start?mode=popup', { headers: { 'x-access-token': isAuth }});
                    if (s?.data?.authUrl) setGmailAuthUrl(s.data.authUrl);
                } catch(_) {}
                setStartPending(false);
                setGmailFlow('multi');
                setShowEmailPermModal(true);
                return; // wait for user to connect
            }
        } catch (e) {
            setStartPending(false);
            // proceed anyway for non-gmail or on error
        }
        setStartPending(false);
        startProcessingWithSelected(selectedJobIds);
    };

    const handleProcessingClose = () => {
        setProcessingMinimized(true);
    };

    const handleProcessingStop = async () => {
        // Show spinner while we request stop; keep view visible until done
        setStopPending(true);
        try {
            if (processingBatchId) {
                await axios.post(`/user/auto-apply/stop/${encodeURIComponent(processingBatchId)}`, {}, { headers: { 'x-access-token': isAuth } });
            }
        } catch(_) { /* ignore */ }
        // After stop completes (or errors), clear processing state
        setProcessingActive(false);
        setProcessingMinimized(false);
        setProcessingJobs([]);
        setProcessingCounts({ done: 0, total: 0 });
        setPerJobStatuses([]);
        setPerJobStages([]);
        setProcessingBatchId(null);
        setStopPending(false);
        // Reset any selections and ensure multi-select mode is off
        setSelectedJobIds([]);
        setMultiApplyMode(false);
    };

    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();
    const infoSetter = useInfoSetter();

    const checkIfAuth = useCallback(async () => {
        try {
            //must await
            await checkAuthenticatedUser()
        } catch (error) {
            dispatch(setFetching(false));
            return navigate("/popin?job-hub");      
        }
    }, [dispatch, navigate]);

    const handleNavigateProfile = (e) => {
        if (e) e.preventDefault();
        const prevPath = location.pathname
        sessionStorage.setItem("prevPath", prevPath)
        navigate("/user/dashboard/profile")
    }

     // Effects
    useEffect(() => {
        checkIfAuth()
        const feedback = localStorage.getItem('feedbackTime');
        const successfulTargetAchievement = localStorage.getItem("successfulTargetAchievement")

        if(successfulTargetAchievement) {
            openSuccessfulAchievement(true)
            localStorage.removeItem("successfulTargetAchievement")
        }

        if (feedback) {
            const timer = setTimeout(() => {
                setIsFeedbackTime(true);
            }, 60000);

            return () => clearTimeout(timer);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Render pricing modal when needed
    // placed near top-level JSX via state-driven modal

    const loadJobs = useCallback(async (skip) => {
        if (isFetching.current) return;  //prevent multiple fetching in runtime
        isFetching.current = true;
        
        if (skip > 0) {
            setLoadingJobs(true);
        } else {
            dispatch(setFetching(true));
        }

        try {
            const response = await axios.get('/user/job-hub', {
                headers: { 
                    "x-access-token": isAuth,
                    skip: skip,
                    limit: 10
                }
            });

            if (response?.data?.status === "unauthenticated") {
                localStorage?.removeItem("token");
                return navigate("/popin?job-hub");
            }

            const data = response.data;
            setJobs(prev => skip === 0 ? data.jobs : [...prev, ...data.jobs]);
            setHasMoreJobs(data.jobs.length === 10);

            // if (skip === 0) {
                dispatch(setResumeSubDuration(data.subDuration));
                dispatch(setResumeServicesNumbers(data.resumeTotalNumbers));
                dispatch(setIsResumeSubbed(data.resumeSub));
                dispatch(setUserFirstName(data.firstName))
                dispatch(setProfileImg(data.profileImg))
                setAllResumes(data.resumes);
                setIsFirstFreeUsed(data.isFirstFreeUsed);

                // removed unused application mapping logic
            // }

        } catch (error) {
            console.error("Error loading jobs:", error);
        } finally {
            isFetching.current = false;
            setLoadingJobs(false);
            dispatch(setFetching(false));
            // mark initial populate done after the first/top-level load (skip === 0)
            try {
                if (typeof skip === 'number' && skip === 0 && !initialPopulateDoneRef.current) {
                    initialPopulateDoneRef.current = true;
                    setInitialPopulateDone(true);
                }
            } catch (_) {}
        }
    }, [dispatch, isAuth, navigate]);

    const handleJobListScroll = useCallback(() => {
        const el = jobListRef.current;
        if (!el) return;
        // Check if scrolled to bottom
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
            if (!isFetching.current && hasMoreJobs) {
                const newSkip = skipCount + 10;
                setSkipCount(newSkip);
                loadJobs(newSkip);
            }
        }
    }, [skipCount, hasMoreJobs, loadJobs]);

    useEffect(() => {
        const el = jobListRef.current;
        if (!el) return;
        el.addEventListener('scroll', handleJobListScroll);
        return () => el.removeEventListener('scroll', handleJobListScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skipCount, jobs.length, hasMoreJobs]);

    useEffect(() => {
        checkIfAuth()

        //Initial load
        if (!isEffectExecuted.current) {
            loadJobs(0);
            isEffectExecuted.current = true;
        }
        // Fetch Gmail permission status for header chip
        (async () => {
            try {
                const r = await axios.get('/user/gmail/permission-status', { headers: { 'x-access-token': isAuth }});
                setGmailIsGmail(!!r?.data?.isGmail);
                setGmailGranted(!!r?.data?.granted);
            } catch(_){ /* ignore */ }
        })();
        // Handle Gmail OAuth redirect
        try {
            const params = new URLSearchParams(window.location.search);
            if (params.get('gmail') === 'connected') {
                // Determine flow from session storage (popup fallback path)
                let flow = 'multi';
                try { flow = sessionStorage.getItem('gmailFlow') || 'multi'; } catch(_) {}
                // Message depends on flow
                if (flow === 'schedule') {
                    successSetter('Gmail connected');
                } else {
                    successSetter('Gmail connected. Starting auto-apply now.');
                }
                setGmailGranted(true);
                setGmailIsGmail(true);
                window.history.replaceState({}, document.title, window.location.pathname);
                try {
                    if (sessionStorage.getItem('resumeAfterGmail') === '1') {
                        const raw = sessionStorage.getItem('multiApplySelected');
                        const ids = raw ? JSON.parse(raw) : [];
                        sessionStorage.removeItem('resumeAfterGmail');
                        sessionStorage.removeItem('multiApplySelected');
                        try { sessionStorage.removeItem('gmailFlow'); } catch(_) {}
                        if (flow === 'multi' && Array.isArray(ids) && ids.length) {
                            startProcessingWithSelected(ids);
                        }
                    }
                } catch(_){}
            } else if (params.get('gmail') === 'error') {
                errorSetter('Failed to connect Gmail. You can retry when starting auto-apply.');
                window.history.replaceState({}, document.title, window.location.pathname);
            }
        } catch(_) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Listen for job connect & external job add SSE events, and auto-apply batch events
    useEffect(() => {
    const token = localStorage.getItem('token');
    const es = new EventSource(`/user/progress${token ? `?token=${encodeURIComponent(token)}` : ''}`);
        es.onmessage = (event) => {
            try {
                const payload = JSON.parse(event.data);
                // --- Auto-Apply batch events ---
                if (payload && (payload.type === 'autoApplyStarted' || payload.type === 'autoApplyProgress' || payload.type === 'autoApplyUpdate' || payload.type === 'autoApplyDone')) {
                    const sameBatch = processingBatchId && payload.batchId && String(payload.batchId) === String(processingBatchId);
                    const currentUserId = user?._id || user?.id || user?.uid || user?.userId;
                    const sameUser = currentUserId && payload.userId && String(payload.userId) === String(currentUserId);
                    if (sameBatch || sameUser) {
                        // Map backend stages/messages to friendly crawl messages for single-job Try Again flow
                        const stageToMessage = (stage, fallback) => {
                            if (payload && payload.message) return payload.message;
                            switch ((stage || '').toLowerCase()) {
                                case 'email_discovery': return 'Searching for recruiter email...';
                                case 'email_normalize': return 'Verifying found emails...';
                                case 'gmail_connect': return 'Connecting to Gmail...';
                                case 'verifying_email': return 'Verifying recipient email...';
                                case 'resume_optimize': return 'Optimizing resume for this job...';
                                case 'cover_letter': return 'Preparing cover letter...';
                                case 'sending_email': return 'Sending application email...';
                                case 'sent': return 'Application sent.';
                                case 'queued': return 'Queued for processing...';
                                default: return fallback || 'Processing application...';
                            }
                        };

                        // If backend provided a stage/message, surface it to the crawl loader **only** when
                        // this is a Try-Again flow or the processing view has been minimized.
                        try {
                            const possibleStage = payload.stage || payload.status || null;
                            const msg = stageToMessage(possibleStage, payload.message || null);
                            if (msg) {
                                if (tryAgainActiveRef.current || processingMinimizedRef.current) {
                                    setCrawlMessage(msg);
                                    setCrawlLoader(true);
                                } else {
                                    // In multi-select active view, log the message for debugging but do not show crawl loader
                                    console.debug('[JobHub] suppressed crawl loader (multi-select active):', { msg, stage: possibleStage });
                                }
                            }
                        } catch(_) {}
                        if (payload.type === 'autoApplyStarted' || payload.type === 'autoApplyProgress') {
                            const incomingDone = (typeof payload.done === 'number') ? payload.done : null;
                            const incomingTotal = (typeof payload.total === 'number') ? payload.total : null;
                            setProcessingCounts(prev => {
                                const prevDone = (typeof prev?.done === 'number') ? prev.done : 0;
                                const prevTotal = (typeof prev?.total === 'number') ? prev.total : (processingJobs.length || 0);
                                const nextDone = (incomingDone === null) ? prevDone : Math.max(prevDone, incomingDone);
                                const nextTotal = (incomingTotal === null) ? prevTotal : Math.max(prevTotal, incomingTotal);
                                return { done: nextDone, total: nextTotal };
                            });
                            if (typeof payload.index === 'number') {
                                setPerJobStatuses(prev => {
                                    const next = prev.slice();
                                    if (payload.index >= 0 && payload.index < next.length) next[payload.index] = 'running';
                                    return next;
                                });
                                // If stage included, update stages map too
                                if (payload.stage) {
                                    setPerJobStages(prev => {
                                        const next = prev.slice();
                                        if (payload.index >= 0 && payload.index < next.length) next[payload.index] = payload.stage;
                                        return next;
                                    });
                                }
                            }
                        }
                        if (payload.type === 'autoApplyUpdate') {
                            const incomingDone = (typeof payload.done === 'number') ? payload.done : null;
                            const incomingTotal = (typeof payload.total === 'number') ? payload.total : null;
                            setProcessingCounts(prev => {
                                const prevDone = (typeof prev?.done === 'number') ? prev.done : 0;
                                const prevTotal = (typeof prev?.total === 'number') ? prev.total : (processingJobs.length || 0);
                                const nextDone = (incomingDone === null) ? prevDone : Math.max(prevDone, incomingDone);
                                const nextTotal = (incomingTotal === null) ? prevTotal : Math.max(prevTotal, incomingTotal);
                                return { done: nextDone, total: nextTotal };
                            });
                            if (typeof payload.index === 'number') {
                                const status = (payload.job && payload.job.status) || 'processing';
                                setPerJobStatuses(prev => {
                                    const next = prev.slice();
                                    if (payload.index >= 0 && payload.index < next.length) next[payload.index] = status;
                                    return next;
                                });
                                if (payload.stage) {
                                    setPerJobStages(prev => {
                                        const next = prev.slice();
                                        if (payload.index >= 0 && payload.index < next.length) next[payload.index] = payload.stage;
                                        return next;
                                    });
                                    // If backend signals 'sent', make sure status becomes success
                                    if (payload.stage === 'sent') {
                                        setPerJobStatuses(prev => {
                                            const next = prev.slice();
                                            if (payload.index >= 0 && payload.index < next.length) next[payload.index] = 'success';
                                            return next;
                                        });
                                    }
                                }
                            } else if (payload.job) {
                                // Robustly map payload job to index in processingJobs using multiple id/url fallbacks
                                const payloadJobKey = String(payload.job.job?.id || payload.job.id || payload.job.job_id || payload.job.external_url || '');
                                const idx = processingJobs.findIndex(j => {
                                    try {
                                        const candidate = String(j.id || j.job_id || j.jobId || j.final_url || j.url || getJobIdentifier(j) || '');
                                        return candidate && payloadJobKey && (candidate === payloadJobKey || getJobIdentifier(j) === payloadJobKey);
                                    } catch(_) { return false; }
                                });
                                if (idx >= 0) {
                                    const status = (payload.job && payload.job.status) || 'processing';
                                    setPerJobStatuses(prev => {
                                        const next = prev.slice();
                                        next[idx] = status;
                                        return next;
                                    });
                                    if (payload.stage) {
                                        setPerJobStages(prev => {
                                            const next = prev.slice();
                                            next[idx] = payload.stage;
                                            return next;
                                        });
                                        if (payload.stage === 'sent') {
                                            setPerJobStatuses(prev => {
                                                const next = prev.slice();
                                                next[idx] = 'success';
                                                return next;
                                            });
                                        }
                                    }
                                }
                            }
                            // Also update the global jobs list when backend provides job-level info
                            try {
                                if (payload.job) {
                                    setJobs(prevJobs => prevJobs.map(j => {
                                        try {
                                            const jId = String(j.id || j.job_id || j.jobId || '');
                                            const pId = String(payload.job.jobId || (payload.job.job && payload.job.job.id) || payload.job.id || '');
                                            if (pId && jId && String(pId) === String(jId)) {
                                                const success = (payload.job && (payload.job.status === 'success' || payload.job.result === 'success')) || (payload.stage === 'sent') || (payload.success === true);
                                                return { ...j, applied: success ? true : j.applied, attemptedEmailAutoApply: success ? false : j.attemptedEmailAutoApply };
                                            }
                                        } catch(_) {}
                                        return j;
                                    }));
                                }
                            } catch(_) {}
                        }
                        if (payload.type === 'autoApplyDone') {
                            setProcessingCounts(prev => ({ ...prev }));
                            setProcessingBatchId(null);
                            setProcessingActive(false);
                            setProcessingMinimized(false);
                            // Hide any crawl loader UI that may be showing for a single-job retry
                            try { setCrawlLoader(false); } catch(_) {}

                            // Update job(s) status in UI so Try Again buttons disappear and badges update.
                            try {
                                const applyJobs = [];
                                if (Array.isArray(payload.jobs) && payload.jobs.length) applyJobs.push(...payload.jobs);
                                if (payload.job) applyJobs.push(payload.job);
                                // Normalize job identifiers and update the jobs list
                                if (applyJobs.length) {
                                    setJobs(prevJobs => {
                                        const next = prevJobs.map(j => {
                                            try {
                                                const jId = String(j.id || j.job_id || j.jobId || '');
                                                // find matching payload job
                                                const match = applyJobs.find(p => {
                                                    const pId = String(p.job?.id || p.id  || p.jobId || p.job_id || '');
                                                    if (pId && jId && String(pId) === String(jId)) return true;
                                                    // fallback: match by url/final_url
                                                    try {
                                                        const pUrl = (p.url || p.external_url || (p.job && (p.job.url || p.job.final_url)) || '').toString();
                                                        const jUrl = (j.url || j.external_url || j.job_url || '').toString();
                                                        if (pUrl && jUrl && pUrl === jUrl) return true;
                                                    } catch(_) {}
                                                    return false;
                                                });
                                                if (match) {
                                                    // If backend indicates success for this job, mark as applied and clear attempted flag
                                                    const success = (match.status === 'success') || (match.result === 'success') || (match.stage === 'sent') || (payload.success === true);
                                                    return { ...j, applied: success ? true : j.applied, attemptedEmailAutoApply: success ? false : j.attemptedEmailAutoApply };
                                                }
                                            } catch(_) {}
                                            return j;
                                        });
                                        return next;
                                    });
                                }
                            } catch(_) {}

                            // Show success or failure message depending on backend payload
                            try {
                                if (payload && (payload.success === false || payload.failed === true || payload.error)) {
                                    const msg = payload.error || 'Auto-apply finished with errors.';
                                    errorSetter(msg);
                                } else {
                                    successSetter('Auto-apply finished');
                                }
                            } catch(_) {}

                            // If this completion belongs to a flow the user initiated (multi-select processing
                            // or a try-again single-job flow), navigate to Completed Applications so the
                            // user can review results. Add a short delay so toasts/messages are visible.
                            try {
                                if (processingActive || tryAgainActiveRef.current) {
                                    // clear try-again marker
                                    tryAgainActiveRef.current = false;
                                    setTimeout(() => {
                                        try { navigate('/user/dashboard/auto-apply'); } catch(_) {}
                                    }, 700);
                                }
                            } catch(_) {}
                        }
                        // Stop further handling of this message
                        return;
                    }
                }
                // External job add events — filter to current request or current user
                const matchesCurrentAdd = (!!pendingAddRef.current && payload.requestId && String(payload.requestId) === String(pendingAddRef.current));
                const currentUserId = user?._id || user?.id || user?.uid || user?.userId;
                const matchesUser = (!!currentUserId && payload.userId && String(payload.userId) === String(currentUserId));
                // Use normalized URL matching to avoid exact-string mismatches (protocol, trailing slash, etc)
                const lastAddNormalized = lastAddUrlRef.current ? normalizeUrlForMatch(lastAddUrlRef.current) : null;
                const payloadUrlRaw = payload.url || payload.external_url || (payload.job && (payload.job.url || payload.job.external_url || payload.job.final_url));
                const payloadUrlNormalized = payloadUrlRaw ? normalizeUrlForMatch(payloadUrlRaw) : null;
                const matchesUrl = lastAddNormalized && payloadUrlNormalized && lastAddNormalized === payloadUrlNormalized;

                if (payload.type === 'externalJobProgress' && (matchesCurrentAdd || matchesUser || matchesUrl)) {
                    // Don't rely on component state captured in closure; handle any matching progress updates
                    if (typeof payload.percent === 'number') setProgressPercentage(payload.percent);
                    if (payload.message) setProgressStatus(payload.message);
                    setAddingJobMessage(payload.message || 'Processing job');
                    // If backend reports completion for our request, clear refs and reload jobs
                    if (payload.stage === 'completed' && matchesCurrentAdd) {
                        setAddingJob(false);
                        if (addJobTimeoutRef.current) { clearTimeout(addJobTimeoutRef.current); addJobTimeoutRef.current = null; }
                        pendingAddRef.current = null;
                        setProgressPercentage(100);
                        setProgressStatus('Job added');
                        // Reload jobs list to reflect the new entry
                        loadJobs(0);
                    }
                    return;
                }
                if (payload.type === 'externalJobAdded' && (matchesCurrentAdd || matchesUser || matchesUrl)) {
                    setAddingJob(false);
                    if (addJobTimeoutRef.current) { clearTimeout(addJobTimeoutRef.current); addJobTimeoutRef.current = null; }
                    pendingAddRef.current = null;
                    setProgressPercentage(100);
                    setProgressStatus('Job added');
                    successSetter('Job added successfully');
                    if (payload.job) {
                        // Deduplicate before insert
                        setJobs(prev => {
                            const exists = prev.some(j => (j?.id && payload.job?.id && String(j.id) === String(payload.job.id)) || (j?.url && payload.job?.url && j.url === payload.job.url) || (j?.external_url && payload.job?.external_url && j.external_url === payload.job.external_url));
                            if (exists) return prev;
                            // Save the job reference to allow immediate "Apply for Me" flow
                            try { setAddedJobForApply(payload.job); } catch(_) {}
                            try { setShowApplyAfterAddModal(true); } catch(_) {}
                            return [payload.job, ...prev];
                        });
                    } else {
                        loadJobs(0);
                    }
                    return;
                }
                if (payload.type === 'externalJobFailed' && (matchesCurrentAdd || matchesUser || matchesUrl)) {
                    setAddingJob(false);
                    if (addJobTimeoutRef.current) { clearTimeout(addJobTimeoutRef.current); addJobTimeoutRef.current = null; }
                    pendingAddRef.current = null;
                    setProgressStatus('Failed to add job');
                    errorSetter(payload.error || 'Failed to add job');
                    return;
                }
                // Job connects events (process even if crawlLoader not yet enabled; handle race)
                if (payload.type === 'jobConnectsReady' || payload.type === 'jobConnectsFailed') {
                    const resumeName = payload.resumeId;
                    const selectedName = singleResume?.storageDetails?.name || singleResume?.id || '';
                    if (resumeName && selectedName && String(resumeName) === String(selectedName)) {
                        // Mark pending resolved
                        jobConnectPendingRef.current = null;
                        // Ensure crawl modal closed & loader hidden
                        setShowCrawlModal(false);
                        setCrawlLoader(false);
                        if (payload.type === 'jobConnectsReady') {
                            setCrawlMessage('Matches found!');
                            successSetter('New job connections are ready');
                            loadJobs(0);
                        } else {
                            setCrawlMessage('Failed to fetch matches');
                            errorSetter('Failed to fetch job matches. Try again later.');
                        }
                    }
                    return; // handled
                }
            } catch (e) {
                // ignore non-json or unrelated SSE messages
            }
        };
        return () => {
            try { es.close(); } catch (e) {}
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [crawlLoader, singleResume, errorSetter, successSetter, processingBatchId, processingJobs.length, processingCounts.total]);

    // Listen for Try-Again events triggered from JobView to show the crawl loader UI
    useEffect(() => {
        const onStart = (ev) => {
            try {
                const msg = ev && ev.detail && ev.detail.message ? ev.detail.message : 'Retrying application...';
                // Mark try-again flow active so SSE knows to surface crawl UI
                tryAgainActiveRef.current = true;
                console.debug('[JobHub] tryAgain:start received', { message: msg, batchId: ev?.detail?.batchId });
                setCrawlMessage(msg);
                setCrawlLoader(true);
                // If a batchId was provided by the starter, set processingBatchId so SSE can be scoped
                try {
                    const bid = ev && ev.detail && ev.detail.batchId ? String(ev.detail.batchId) : null;
                    if (bid) setProcessingBatchId(bid);
                } catch(_) {}
            } catch(_) {}
        };
        const onStop = () => {
            try { setCrawlLoader(false); } catch(_) {}
            tryAgainActiveRef.current = false;
        };
        window.addEventListener('tryAgain:start', onStart);
        window.addEventListener('tryAgain:stop', onStop);
        return () => {
            window.removeEventListener('tryAgain:start', onStart);
            window.removeEventListener('tryAgain:stop', onStop);
        };
    }, []);

    // Listen for custom gmail_connected events (dispatched by child components as a fallback)
    useEffect(() => {
        const handler = () => {
            try {
                // Treat like a successful connect; attempt to resume any pending flows
                let flow = 'multi';
                try { flow = sessionStorage.getItem('gmailFlow') || 'multi'; } catch(_) {}
                setGmailGranted(true);
                setGmailIsGmail(true);
                try {
                    const raw = sessionStorage.getItem('multiApplySelected');
                    const ids = raw ? JSON.parse(raw) : [];
                    sessionStorage.removeItem('resumeAfterGmail');
                    sessionStorage.removeItem('multiApplySelected');
                    try { sessionStorage.removeItem('gmailFlow'); } catch(_) {}
                    if (flow === 'multi' && Array.isArray(ids) && ids.length) {
                        startProcessingWithSelected(ids);
                    } else {
                        successSetter('Gmail connected');
                    }
                } catch(_) {
                    try { successSetter('Gmail connected'); } catch(_) {}
                }
            } catch(_) {}
        };
        try { window.addEventListener('gmail_connected', handler); } catch(_) {}
        return () => { try { window.removeEventListener('gmail_connected', handler); } catch(_) {} };
    }, []);


    useEffect(() => {
        if (showFieldAnswersModal && fieldAnswers && fieldAnswersJob && singleResume) {
            saveApplicationToBackend({
                job: fieldAnswersJob,
                method: 'company-site',
                resume: singleResume,
                qaPairs: fieldAnswers.map(f => ({ question: f.label, answer: f.value })),
            });
        }
        // eslint-disable-next-line
    }, [showFieldAnswersModal]);

    useEffect(() => {
        if (showQnAModal && loginQnAList.length > 0 && chosenJob && singleResume) {
            saveApplicationToBackend({
                job: chosenJob,
                method: 'linkedin',
                resume: singleResume,
                qaPairs: loginQnAList,
            });
        }
        // eslint-disable-next-line
    }, [showQnAModal, loginQnAList]);

    // Helper to save application to backend
    const saveApplicationToBackend = async ({ job, method, resume, qaPairs }) => {
        try {
            await axios.post('/user/save-application', {
                jobId: job?.id,
                jobTitle: job?.job_title || job?.title,
                companyName: job?.company_name,
                applicationMethod: method,
                resumeUsed: resume?.id || resume?.storageDetails?.name,
                qaPairs: qaPairs || [],
                status: 'completed',
            }, { headers: { 'x-access-token': isAuth } });
        } catch (err) {
            errorSetter('Failed to save application.');
        }
    };

    const handleResumeSelect = (index) => {
        setSingleResume(allResumes[index]);
        //Adding plus one to allow for 0 to signify no resume selected to user
        setActiveResIndex(index + 1);
        try { holisticAnalytics.track('ui.feature_used', { featureUsed: 'service_redirect', eventData: { action: 'resume.select', resumeName: allResumes[index]?.storageDetails?.name } }); } catch(_){}
    };

    const handleResumePreviewIntent = (resume) => {
        if (!resume) {
            errorSetter('Preview unavailable. Select a different resume.');
            return;
        }
        try {
            holisticAnalytics.track('ui.feature_used', {
                featureUsed: 'service_redirect',
                eventData: { action: 'resume.preview_intent', resumeName: resume?.storageDetails?.name }
            });
        } catch(_){ }
        setPreviewResume(resume);
        setPreviewModalOpen(true);
    };

    const closeResumePreview = () => {
        setPreviewModalOpen(false);
        setPreviewResume(null);
    };

    const toggleMenu = () => {
        setAuthMenuOpen(!authMenuOpen);
        try { holisticAnalytics.track('ui.feature_used', { featureUsed: 'service_redirect', eventData: { action: 'jobhub.menu_toggle', opened: !authMenuOpen } }); } catch(_){}
    };

    const goBackPrevPage = () => {
        navigate('/user/dashboard/resume');
    };



    const getResume = (description, title) => {
        checkIfAuth()
        try { holisticAnalytics.track('ui.feature_used', { featureUsed: 'service_redirect', eventData: { action: 'jobhub.get_resume_clicked', hasDescription: !!description } }); } catch(_){}
        if(!isResumeSubbed) {
            errorSetter("Upgrade your subscription to access this feature")
            if (!pricingOpened) {
                setPricingOpened(true);
            }
        } else {
            if (!isFirstFreeUsed && resumeServicesNumbers.resumeCreated >= 3) {
                errorSetter("You have reached the maximum number of free trial resumes. Please choose a plan to create more.");
                
                    setPricingOpened(true);
                return
            }
            if(!description) {
                confirm({
                    title: "Description Not Available For This Job",
                    description: `Click Ok if you must continue, but the resulting resume might not be fully optimized for this job.`,
                })
                .then(() => {
                    localStorage.setItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXdescription", description)
                    localStorage.setItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXtitle", title)
                    window.open('/user/dashboard/resume', '_blank')
                })
                .catch(() => {
                    errorSetter('Process Terminated')
                });
            } else {
                confirm({
                    title: "Optimize a resume to this Job?",
                    description: `You will be redirected to upload an old resume which will be automatically tailored for this job. This will 100x your chances. If you prefer not to preview and edit resume, cancel this and use the "Get this Job" button.`,
                })
                .then(() => {
                    localStorage.setItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXdescription", description)
                    localStorage.setItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXtitle", title)
                    window.open('/user/dashboard/resume', '_blank')
                })
                .catch(() => {
                    errorSetter('Process Terminated')
                });
            }
        }

    }

    const getJob = async (linkedinUrl, companyUrl, appCount, job) => {
        setLinkedinUrl(linkedinUrl);
        setCompanyUrl(companyUrl);
        setApplicants(appCount);
        setChosenJob(job);
        setShowInternalAppJobModal(true);
        try { holisticAnalytics.track('ui.feature_discovered', { featureUsed: 'service_redirect', eventData: { action: 'job.view', jobTitle: job?.title, company: job?.company_name } }); } catch(_){}
    };


    const chooseActStr = (action, job) => {
        setActionString(action);
        setChosenJob(job);
        setResumeSelectorModalOpen(true);
        try { holisticAnalytics.track('ui.feature_used', { featureUsed: 'service_redirect', eventData: { action: 'jobhub.action_select', actionName: action, jobTitle: job?.title } }); } catch(_){}
    };

    const handleGenerate = async () => {
        checkIfAuth()
        try { holisticAnalytics.track('ui.feature_used', { featureUsed: 'service_redirect', eventData: { action: 'jobhub.generate_clicked', generateType: actionString } }); } catch(_){}
        if (Object.keys(singleResume).length === 0) {
            errorSetter("Please select a resume first");
            return;
        }
        switch (actionString) {
            case "Cover Letter":
                const date = getOrdinalDate()
                const companyName = chosenJob?.company_name
                const jobDesc = chosenJob?.description
                const jobPosition = chosenJob?.title
                const imgUrl = singleResume?.storageDetails?.imgUrl
                const template = singleResume?.storageDetails?.template

                localStorage?.removeItem("template")            
                localStorage?.removeItem("imgUrl")
                localStorage?.removeItem("resume")
                localStorage?.removeItem("letter")
                
                const prompt = `You are the best professional cover letter writer in the world, 
                    with 100% success rate from your cover letter writings. Write a stunning professional 
                    cover letter that uses relevant keywords from the below job details and my resume to show how I am best-fit for the job:
                    Job Position: ${jobPosition}, 
                    Job Description: ${jobDesc}, Company Name: ${companyName}, My resume object : ${JSON.stringify(singleResume)}, 
                    pick out the candidate name from keys firstName for First Name and lastName for Last Name within 
                    the basicInfo object of the resume; pick out the candidate's work history and all other elements 
                    needed to write the best cover letter from the resume object and Date: ${date}. NOTES: Do not include any 
                    links or addressing or contact details or place holders e.g [Your Email] [Your Mobile] [Hiring Manager’s Name] to the cover letter. 
                    Start with Date, then Dear Hiring Manager and return just the cover letter, with no explanations`
                
                try {
                    dispatch(setFetching(true))
                    let response = await axios.post("/cover-letter", { prompt }, {
                        headers: {
                            "x-access-token": isAuth,
                        },
                    });

                    dispatch(setFetching(false))
                    try { holisticAnalytics.track('cover_letter.created', { featureUsed: 'cover_letter' }); } catch(_){ }
                    // Backend may return quota as a 200 with status field
                    if (response?.data?.status === 'quota') {
                        const statusCode = response.status;
                        if (statusCode === 403 && response.data.openPricing) {
                            setPricingOpened(true);
                            errorSetter(response.data.message || 'Free tier quota reached. Upgrade to continue.');
                            return;
                        }
                        if (statusCode === 429) {
                            errorSetter(response.data.message || 'Daily cover letter quota reached. Try again tomorrow.');
                            return;
                        }
                        errorSetter(response.data.message || 'Cover letter quota reached.');
                        return;
                    }

                    localStorage.setItem("template", template)            
                    localStorage.setItem("resume", JSON.stringify(singleResume))            
                    localStorage.setItem("imgUrl", imgUrl)
                    localStorage.setItem("letter", response.data)
                    dispatch(setFetching(false))
                    successSetter("Your Cover Letter opens in a new tab in 3 seconds")
                    //Navigate in a Cover Letter page
                    setTimeout(() => {
                        window.open("/cover-letter", "_blank");
                    }, 3000);
                } catch (error) {
                    dispatch(setFetching(false))
                    try { holisticAnalytics.track('error_occurred', { featureUsed: 'service_redirect', eventData: { action: 'cover_letter_inline_failed', message: error.message } }); } catch(_){}
                    // Axios error object may include backend response
                    const resp = error?.response;
                    if (resp && resp.data && resp.data.status === 'quota') {
                        const statusCode = resp.status;
                            if (statusCode === 403 && resp.data.openPricing) {
                                setPricingOpened(true);
                            errorSetter(resp.data.message || 'Free tier quota reached. Upgrade to continue.');
                            return;
                        }
                        if (statusCode === 429) {
                            errorSetter(resp.data.message || 'Daily cover letter quota reached. Try again tomorrow.');
                            return;
                        }
                        errorSetter(resp.data.message || 'Cover letter quota reached.');
                        return;
                    }
                    errorSetter("Failed to generate Cover Letter, Try again")
                }

                break;
                
            case "Email":
                const emailPrompt = `Draft a follow-up email regarding my 
                    job application for the Job Title: ${chosenJob?.title} and Company Name: ${chosenJob?.company_name}. I would like the email to be short, professional, human-like and polite, 
                    expressing my continued interest in the position and inquiring about the status of my application. 
                    Additionally, using details from this resume string object: ${JSON.stringify(singleResume)} and the following job description: ${chosenJob?.description}, 
                    please include a very brief reminder of my relevant skills or experiences that make me a strong candidate for this role.`

                localStorage.setItem("HFLHASIGFWFIVQJKVKJJBJKVSHDVHVIVIVIVHVhvhjavcdhuchch_Int_Prep-fu-em_aghgxtdRWYRDWY", emailPrompt)
                successSetter("Your Email opens in a new tab in 3 seconds")
                //Navigate to ask me page
                setTimeout(() => {
                    window.open("/chat", "_blank");
                }, 3000);

                break;
    
            case "Interview":
                const interviewPrompt = `I am preparing for an upcoming job interview for the Job Title: ${chosenJob?.title}, Company Name: ${chosenJob?.company_name}, Job Description: ${chosenJob?.description} 
                    and my resume used for the application is given here in string object form: ${JSON.stringify(singleResume)}. 
                    Please provide a detailed and comprehensive guide that includes the following:
                    Common Interview Questions: List 15 typical questions I might be asked in order of descending importance, along with their corresponding correct answer, exactly as I should nswer them, using all the details I have provided and those you can find on the given company.
                    Company Research: Do a research on the company provided above, its culture, values, and recent news or achievements and feed me with all the info you can find on them.
                    Role-Specific Preparation: Important skills and qualifications related to the job, and how I can demonstrate my expertise in these areas during the interview.
                    Behavioral Questions: Examples of behavioral questions and the STAR (Situation, Task, Action, Result) method to structure my responses.
                    Questions to Ask the Interviewer: Thoughtful questions I can ask at the end of the interview to show my interest and engagement.
                    Body Language and Presentation: Tips on how to present myself confidently and effectively during the interview.
                    Follow-Up Strategy: Guidance on how and when to follow up after the interview.
                    Thank you for your help in preparing me for this important opportunity!`

                localStorage.setItem("HFLHASIGFWFIVQJKVKJJBJKVSHDVHVIVIVIVHVhvhjavcdhuchch_Int_Prep-fu-em_aghgxtdRWYRDWY", interviewPrompt)
                infoSetter("Your Interactive Interview Mock opens in 3 seconds")
                //Navigate in a Cask me page
                setTimeout(() => {
                    window.open("/chat", "_blank");
                }, 3000);
                break;
        
            default:
                break;
        }
        
    }

    const deleteJob = async (jobId, title) => {
        // Returns a promise resolving to { ok: boolean, cancelled?: boolean }
        checkIfAuth();
        try {
            await confirm({
                title: "Delete This Job",
                description: `Are you sure you want to remove ${title} from your job connections?`,
            });
        } catch(_) {
            // user cancelled
            errorSetter('Process Terminated');
            return { ok: false, cancelled: true };
        }

        try {
            await axios.post(`/user/delete-job`, { jobId }, {
                headers: { "x-access-token": localStorage.getItem("token") }
            });
            // Remove job from state
            setJobs(prev => prev.filter(job => job.id !== jobId));
            successSetter("Job removed successfully");
            return { ok: true };
        } catch (error) {
            errorSetter("Failed to remove job");
            return { ok: false };
        }
    };

    // --- SEMI-AUTO APPLY HANDLERS ---
    const handleCopy = (value, isAppFormLinkOpener) => {
        copyText(value)
            .then(() => {
                if (!isAppFormLinkOpener) {
                    successSetter('Copied!');
                } else {
                    successSetter('Link Copied! Paste and open in a new tab');
                }
            })
            .catch((err) => {
                try { window.prompt('Copy this:', value); } catch(_) {}
            });
    };

    const handleApplicationLinkCopy = (value) => {
        copyText(value)
            .then(() => successSetter('Link Copied! Paste in new browser tab and apply'))
            .catch(() => { try { window.prompt('Copy this link:', value); } catch(_) {} });
    };
    
    const checkPremiumSubsAndFirstTrial = () => {
        // Check if user is subscribed and for per month or per week
        if (!isResumeSubbed || resumeSubDuration === "Per Use") {
            errorSetter("Upgrade your subscription to access this feature");
                setPricingOpened(true);
            return false;
        }
        if (!isFirstFreeUsed && resumeServicesNumbers?.jobsApplied >= 5) {
            errorSetter("You have reached the maximum number of free tier Ai job applications. Please choose a plan to do more.");
                setPricingOpened(true);
            return false;
        }

        return true
    }

    const handleCompanySiteAutoApply = async (url) => {
        checkIfAuth()
        setProgressPercentage(1);
        setProgressStatus('Starting...');
        // Check if user is subscribed and for per month or per week
        if (isCompanyAutoApplyTriggered.current) {
            errorSetter("double call triggered, reload page or navigate out and back if error persists")
            return
        }
        isCompanyAutoApplyTriggered.current = true
        if (checkPremiumSubsAndFirstTrial() === false) {
            return
        }
        const jobUrl = url || companyUrl || addJobUrl;
        // analytics
        try { holisticAnalytics.track('job.auto_apply.started', { featureUsed: 'job_auto_apply', jobTitle: chosenJob?.title }); } catch(_){ }
        // Completion/failure instrumentation occurs after axios request below.
        //get event progress via SSE
        const token1 = localStorage.getItem('token');
        const eventSource = new EventSource(`/user/progress${token1 ? `?token=${encodeURIComponent(token1)}` : ''}`);
        eventSource.onmessage = (event) =>  {
            try {
                const progressUpdate = JSON.parse(event.data);
                if (typeof progressUpdate.percent === 'number') setProgressPercentage(progressUpdate.percent);
                if (progressUpdate.status) setProgressStatus(progressUpdate.status);
            } catch(_){}
        };
        setLoading(true)
        try {
            const res = await axios.post('/user/form-analysis/company-site', {
                job: chosenJob,
                resume: singleResume,
                url: jobUrl
            }, { headers: { 'x-access-token': isAuth } });
            if (res.data.pageType === 'login') {
                // If login page detected, trigger login QnA modal
                setShowFieldAnswersModal(false);
                setLoginQnAJobDesc(chosenJob.description);
                setLoginQnAJobDescSaved(true);
                setShowQnAModal(true);
                setAddJobUrl(jobUrl);
                
                setLoading(false);
                eventSource.close()
                return;
            }
            if (res.data.pageType === 'main-form' && res.data.fields) {
                setFieldAnswers(res.data.fields);
                // setSingleResume(res.data.optimizedResume)
                setFieldAnswersUrl(jobUrl);
                setFieldAnswersJob(chosenJob);

                setShowFieldAnswersModal(true);
            } else {
                errorSetter(res.data.message || 'Failed to analyze form. Try again.');
            }
            isCompanyAutoApplyTriggered.current = false
            setLoading(false);
            eventSource.close()
            try { holisticAnalytics.track('job.auto_apply.completed', { featureUsed: 'job_auto_apply', jobTitle: chosenJob?.title }); } catch(_){ }
        } catch (err) {
            isCompanyAutoApplyTriggered.current = false
            setLoading(false);
            eventSource.close()
            errorSetter('Failed to analyze form. Try again.');
            try { holisticAnalytics.track('job.auto_apply.failed', { featureUsed: 'job_auto_apply', jobTitle: chosenJob?.title, errorMessage: err?.message }); } catch(_){ }
        }
    };

    const handleGetResumeDirect = async () => {
        //user can create resume as long as susbscribed, no matter the plan
        if (!isResumeSubbed) {
            errorSetter("Upgrade your subscription to tailor a resume for this job");
            setPricingOpened(true);
            return;
        }
        checkIfAuth()
        setLoading(true)
        setProgressPercentage(0);
        setProgressStatus('Starting...');
        //check for job description before allowing resume optimization and download
        if (!loginQnAJobDescSaved || loginQnAEditingDesc) {
            // Auto-save description if we have a LinkedIn URL
            if (linkedinUrl) {
                if (!loginQnAJobDesc) {
                    setLoginQnAJobDesc(chosenJob?.description || "");
                }
                setLoginQnAJobDescSaved(true);
                setLoginQnAEditingDesc(false);
            } else {
                errorSetter("Save job description first");
                return;
            }
        }
        //get event progress
        const token2 = localStorage.getItem('token');
        const eventSource = new EventSource(`/user/progress${token2 ? `?token=${encodeURIComponent(token2)}` : ''}`);
        let awaitingJobId = null;
        //listen for SSE (progress + completion)
        eventSource.onmessage = (event) =>  {
            try {
                const progressUpdate = JSON.parse(event.data)
                if (typeof progressUpdate.percent === 'number') setProgressPercentage(progressUpdate.percent);
                if (progressUpdate.status) setProgressStatus(progressUpdate.status);
                if (progressUpdate && progressUpdate.type === 'resumeJobDone' && progressUpdate.jobId && awaitingJobId && progressUpdate.jobId === awaitingJobId) {
                    const optimizedResume = progressUpdate.result?.resume;
                    if (optimizedResume) {
                        downloadResumeDirect(optimizedResume).then(() => {
                            try { 
                                holisticAnalytics.track('resume.optimized', { featureUsed: 'resume_builder' });
                                holisticAnalytics.track('resume.downloaded', { featureUsed: 'resume_builder' }); 
                            } catch(_){ }
                            setLoading(false);
                            eventSource.close();
                            successSetter('Resume downloaded!');
                        }).catch(() => {
                            eventSource.close();
                            setLoading(false);
                            errorSetter('Failed to generate/download resume.');
                        });
                    }
                }
                if (progressUpdate && progressUpdate.type === 'resumeJobFailed' && progressUpdate.jobId && awaitingJobId && progressUpdate.jobId === awaitingJobId) {
                    eventSource.close();
                    setLoading(false);
                    const msg = progressUpdate.error || 'Failed to generate resume.';
                    errorSetter(msg);
                }
            } catch(_) {}
        };

        
        try {
            const response = await axios.post('/user/resume/optimize-and-return', {
                job: chosenJob,
                resume: singleResume
            }, { headers: { 'x-access-token': isAuth } });

            if (response.data.status === "unauthenticated") {
                eventSource.close();
                setLoading(false);
                errorSetter("Session expired. Please login again.");
                localStorage?.removeItem("token");
                return navigate("/popin?job-hub");
            }
            if (response?.data?.status === 'processing' && response?.data?.jobId) {
                awaitingJobId = response.data.jobId;
                // wait for SSE resumeJobDone
            } else if (response?.data?.resume) {
                // backward compat
                const optimizedResume = response.data.resume;
                await downloadResumeDirect(optimizedResume);
                try { 
                    holisticAnalytics.track('resume.optimized', { featureUsed: 'resume_builder' });
                    holisticAnalytics.track('resume.downloaded', { featureUsed: 'resume_builder' }); 
                } catch(_){ }
                setLoading(false);
                eventSource.close();
                successSetter('Resume downloaded!');
            }
        } catch (error) {
            eventSource.close();
            setLoading(false);
            errorSetter('Failed to generate/download resume.');
            try { holisticAnalytics.track('resume.optimization_failed', { featureUsed: 'resume_builder', errorMessage: error?.message }); } catch(_){ }
        }
    };

    const handleGetCoverLetterDirect = async () => {
        checkIfAuth()
        //only check for LOGIN ALGORITHM
        if(!showFieldAnswersModal) {
            if (!loginQnAJobDescSaved || loginQnAEditingDesc) {
                errorSetter("Save job description first");
                return;
            }
        }
        try {
            dispatch(setFetching(true));
            const res = await axios.post('/user/cover-letter/optimize-and-return', {
                resume: singleResume,
                job: fieldAnswersJob || chosenJob
            }, { headers: { 'x-access-token': isAuth } });

            dispatch(setFetching(false));
            if (res?.data?.status === 'quota') {
                const statusCode = res.status;
                if (statusCode === 403 && res.data.openPricing) {
                        setPricingOpened(true);
                    errorSetter(res.data.message || 'Free tier quota reached. Upgrade to continue.');
                    return;
                }
                if (statusCode === 429) {
                    errorSetter(res.data.message || 'Daily cover letter quota reached. Try again tomorrow.');
                    return;
                }
                errorSetter(res.data.message || 'Cover letter quota reached.');
                return;
            }

            await downloadCoverLetterDirect(res.data.coverLetter, singleResume);
            try { 
                holisticAnalytics.track('cover_letter.created', { featureUsed: 'cover_letter' });
                holisticAnalytics.track('cover_letter.downloaded', { featureUsed: 'cover_letter' }); 
            } catch(_){ }
            successSetter('Cover letter downloaded!');
        } catch (err) {
            dispatch(setFetching(false));
            try { holisticAnalytics.track('cover_letter.generation_failed', { featureUsed: 'cover_letter', errorMessage: err?.message }); } catch(_){ }
            const resp = err?.response;
            if (resp && resp.data && resp.data.status === 'quota') {
                const statusCode = resp.status;
                if (statusCode === 403 && resp.data.openPricing) {
                        setPricingOpened(true);
                    errorSetter(resp.data.message || 'Free tier quota reached. Upgrade to continue.');
                    return;
                }
                if (statusCode === 429) {
                    errorSetter(resp.data.message || 'Daily cover letter quota reached. Try again tomorrow.');
                    return;
                }
                errorSetter(resp.data.message || 'Cover letter quota reached.');
                return;
            }
            errorSetter('Failed to generate/download cover letter.');
        }
    };

    const triggerLoginQnAModal = () => {
        setShowFieldAnswersModal(false);
        setShowAddJobModal(false);
        setShowInternalAppJobModal(false);
        setShowQnAModal(true);
    };


    // submit handlers for autoapply
    const handleInternalJobModalSubmit = (method) => {
        checkIfAuth()
        // Check if user is subscribed and for per month or per week
        if (checkPremiumSubsAndFirstTrial() === false) {
            return
        }
        if (Object.keys(singleResume).length < 1) {
            errorSetter("Please select a resume first");
            return;
        }
        if (method === 'linkedin') {
            setLoginQnAJobDesc(chosenJob?.description || "");
            setLoginQnAJobDescSaved(true);
            setLoginQnAEditingDesc(false);
            triggerLoginQnAModal();
            return;
        }
        // Company site
        setShowInternalAppJobModal(false);
        handleCompanySiteAutoApply();
    };

    
 
    // removed old handleExternalModalSubmit logic (replaced by add-job queue flow)

    const handleLoginQnAInputChange = (e) => {
        setLoginQnAInput(e.target.value);
    };

    // Handler for QnA submit
    const handleLoginQnASubmit = async () => {
        checkIfAuth()
        // Check if user is subscribed and for per month or per week
        if (checkPremiumSubsAndFirstTrial() === false) {
            return
        }
        //For QnA Modal
        if(!showFieldAnswersModal) {
            if (!loginQnAInput || !loginQnAJobDesc) {
                errorSetter('Please provide a question and save job description.');
                return;
            }
            try {
                setLoginQnALoading(true);
                const res = await axios.post('/user/form-analysis/login-qna', {
                    resume: singleResume,
                    jobDescription: loginQnAJobDesc,
                    question: loginQnAInput
                }, { headers: { 'x-access-token': isAuth } });
                setLoginQnAList(prev => [...prev, { question: loginQnAInput, answer: res.data.answer }]);
                successSetter("Answer generated!")
            } catch (err) {
                errorSetter('Failed to get answer. Try again.');
            }
        } else {
            //For FieldAnswersModal
            if (!loginQnAInput) {
                errorSetter('Please provide a question.');
                return;
            }
            try {
                setLoginQnALoading(true);
                const res = await axios.post('/user/form-analysis/login-qna', {
                    resume: singleResume,
                    jobDescription: chosenJob?.description,
                    question: loginQnAInput
                }, { headers: { 'x-access-token': isAuth } });
                setFieldAnswers(prev => [...prev, { label: loginQnAInput, value: res.data.answer }]);
                successSetter("Answer generated!")
            } catch (err) {
                errorSetter('Failed to get answer. Try again.');
            }
        }

        setLoginQnAInput('');
        setLoginQnALoading(false);
    };

    // Open crawl modal for fetching new job connects
    const crawlNewJobs = async () => {
        checkIfAuth();
        setShowCrawlModal(true);
    }

    // Submit request to backend to fetch new job connects (front-end only function)
    const fetchNewJobConnects = async () => {
        checkIfAuth();
        if (Object.keys(singleResume).length === 0) {
            errorSetter('Please select a resume first');
            return;
        }
        if (!crawlCountry) {
            errorSetter('Please select a country');
            return;
        }
        if (!crawlState) {
            errorSetter('Please select a state/region');
            return;
        }

        try {
            dispatch(setFetching(true));
            const payload = {
                resume: singleResume?.id || singleResume?.storageDetails?.name,
                country: crawlCountry,
                state: crawlState,
                jobConnectType: crawlJobConnectType
            };
            // Set pending ref early for race handling (use resume identifier kept in jobFetchRunner)
            jobConnectPendingRef.current = singleResume?.storageDetails?.name || singleResume?.id || '';
            // NOTE: this endpoint is assumed for front-end integration — backend should implement '/user/job-hub/fetch-new-connects'
            const res = await axios.post('/user/job-hub/fetch-new-connects', payload, {
                headers: { 'x-access-token': isAuth }
            });

            dispatch(setFetching(false));
            if (res?.data?.status === 'unauthenticated') {
                localStorage?.removeItem('token');
                return navigate('/popin?job-hub');
            }

            // Backend may return a quota object in a 200 response as well
            if (res?.data?.status === 'quota') {
                const statusCode = res.status;
                // If backend asked to open pricing (free user), open once
                if (statusCode === 403 && res.data.openPricing) {
                    // Close modal/loader on quota
                    jobConnectPendingRef.current = null;
                    setShowCrawlModal(false);
                    setCrawlLoader(false);
                    setPricingOpened(true);
                    errorSetter(res.data.message || 'Free tier quota reached. Upgrade to continue.');
                    return;
                }
                // Per-month users hit daily quota (429)
                if (statusCode === 429) {
                    jobConnectPendingRef.current = null;
                    setShowCrawlModal(false);
                    setCrawlLoader(false);
                    errorSetter(res.data.message || 'Daily fetch quota reached. Try again tomorrow.');
                    return;
                }
                // Fallback
                jobConnectPendingRef.current = null;
                setShowCrawlModal(false);
                setCrawlLoader(false);
                errorSetter(res.data.message || 'Daily fetch quota reached.');
                return;
            }

            if (res?.status === 200) {
                const msg = String(res?.data?.message || '').toLowerCase();
                // Close the prompt modal regardless
                setShowCrawlModal(false);
                if (msg.includes('search started')) {
                    infoSetter(res.data.message || 'Search started. We will notify you when matches are found');
                    // Only show loader if SSE completion hasn't already arrived
                    if (jobConnectPendingRef.current) {
                        setCrawlMessage('Searching chosen location for 90%+ matches — may be up to a minute');
                        setCrawlLoader(true);
                    } else {
                        // Event already handled; ensure loader hidden
                        setCrawlLoader(false);
                    }
                } else if (msg.includes('no jobs')) {
                    // No phase-2 in this case
                    jobConnectPendingRef.current = null;
                    setCrawlLoader(false);
                    infoSetter(res.data.message || 'No jobs found, Try after some time');
                } else {
                    // Unknown 200 message: be conservative and not show a long loader
                    jobConnectPendingRef.current = null;
                    setCrawlLoader(false);
                    infoSetter(res.data.message || 'Request received');
                }
            } else {
                // Non-success response; ensure UI not stuck
                jobConnectPendingRef.current = null;
                setShowCrawlModal(false);
                setCrawlLoader(false);
                errorSetter(res.data.message || 'Failed to start job search');
            }
        } catch (err) {
            dispatch(setFetching(false));
            jobConnectPendingRef.current = null; // clear on error
            // Axios throws for non-2xx responses; inspect error response for quota info
            const resp = err?.response;
            const statusCode = resp?.status;
            // Always hide modal/loader on any error
            setShowCrawlModal(false);
            setCrawlLoader(false);
            if (resp && resp.data && resp.data.status === 'quota') {
                if (statusCode === 403 && resp.data.openPricing) {
                    // Close modal/loader on quota
                    jobConnectPendingRef.current = null;
                    setShowCrawlModal(false);
                    setCrawlLoader(false);
                    setPricingOpened(true);
                    errorSetter(resp.data.message || 'Free tier quota reached. Upgrade to continue.');
                    return;
                }
                // Per-month users hit daily quota (429)
                if (statusCode === 429) {
                    jobConnectPendingRef.current = null;
                    setShowCrawlModal(false);
                    setCrawlLoader(false);
                    errorSetter(resp.data.message || 'Daily fetch quota reached. Try again tomorrow.');
                    return;
                }
                errorSetter(resp.data.message || 'Daily fetch quota reached.');
                return;
            }
            // Explicit 402 Payment Required (may not include a quota status body)
            if (statusCode === 402) {
                setPricingOpened(true);
                errorSetter((resp && resp.data && resp.data.message) || 'Upgrade required to fetch new job connects.');
                return;
            }
            console.error('fetchNewJobConnects error', err);
            errorSetter('Failed to start job search. Try again');
        }
    }

    // Render
    return (
        <div>
            {isFeedbackTime ? <Feedback notApaymentTextPositive="Resume Creation Completed!"/> : (
                <div className="auth-container">
                    <UpgradePopup />
                    {pricingOpened && (
                        <ResumePricing closePricing={() => setPricingOpened(false)} open={pricingOpened} />
                    )}
                    <AuthSideMenu
                        opened={authMenuOpen}
                        hidden={!authMenuOpen}
                        resumeSubDuration={resumeSubDuration}
                        isResumeSubbed={isResumeSubbed}
                        arrayDetails={[]}
                    />
                    {/* For SIDE MENU */}
                    <BubbleFloat>
                        <img src={bubblesvg} alt="bubble asset floating"/>
                    </BubbleFloat>

                    <div style={{width: '95%', margin: '0 auto'}}>
                        {/* for TOP MENU */}

                        <AuthHeader
                            authMenuOpen={authMenuOpen}
                            onClick={toggleMenu}
                            headerText="My Jobs"
                        />

                        <div>
                            {/* <div style={{margin: '20px auto', width: screenWidth < 900 ? '100%' : '50%'}}>
                                <AuthInputs
                                    placeholder="Search for a resume"
                                    inputType="search"
                                    mb={3}
                                    mt={5}
                                    required={true}
                                    value={searchString}
                                    onChange={handleSearch}
                                />
                            </div>  */}


                            <TypeWrite onClick={() => setAuthMenuOpen(false)} style={{borderColor: textColor}}>
                                <TypeAnimation
                                    sequence={[
                                        () => setTextColor('#3E8F93'),
                                        1000,
                                        'Greater Than 90% Chance of Beating ATS',
                                        1000,
                                        'Greater Than 90% Chance of Interview',
                                        1000,
                                        'Greater Than 90% Chance of Employment',
                                        1000,
                                        '.',
                                        1000,
                                        () => setTextColor('black'),
                                        'Real Company Data Used in Generating Resume',
                                        1000,
                                        'Real Company Data Used in Generating Cover',
                                        1000,
                                        'Real Company Data Used in Interview Prep',
                                        1000,
                                        '.',
                                        1000,
                                        () => setTextColor('#987070'),
                                        'Enhances User Data to Generate Resume',
                                        1000,
                                        'Enhances User Data to Generate Cover',
                                        1000,
                                        'Enhances User Data in Interview Prep',
                                        1000,
                                        '.',
                                        1000,
                                    ]}
                                    repeat={Infinity}
                                />
                            </TypeWrite>

                            <AssistSectionStyled>
                                <div style={{width: '100%', display: 'flex', flexDirection: 'row', gap: '8px'}}>
                                    <div style={{flex: 1}} ref={jobConnectRef}>
                                        <Button
                                            width="100%"
                                            secondaryLight={true}
                                            clickHandle={crawlNewJobs}
                                        >
                                            Job-Connect Me <TbReplaceFilled/>
                                        </Button>
                                    </div>
                                    <div style={{flex: 1}} ref={viewAppsRef}>
                                        <Button
                                            width="100%"
                                            secondaryLight={true}
                                            link={'/user/dashboard/auto-apply'}
                                        >
                                            View Applications <ImBriefcase />
                                        </Button>
                                    </div>
                                </div>
                                <div style={{width: '100%', display: 'flex', flexDirection: 'row', gap: '8px'}}>
                                    <div style={{flex: 1}} ref={changeLocationRef}>
                                        <Button
                                            width="100%"
                                            secondaryLight={true}
                                            link="/user/dashboard/profile"
                                        >
                                            Change location <FaMapLocationDot/>
                                        </Button>                                    
                                    </div>
                                    <div style={{flex: 1}} ref={addExternalRef}>
                                        <Button
                                            width="100%"
                                            secondaryLight={true}
                                            clickHandle={() => setShowAddJobModal(true)}
                                        >
                                            Add External Job <TbLinkPlus/>
                                        </Button>                                    
                                    </div>
                                </div>
                                {!processingActive && (
                                    <div style={{width: '100%'}} ref={applyForMeRef}>
                                        <Button
                                            width="100%"
                                            primary={true}
                                            link="#"
                                            clickHandle={handlePrimaryApplyClick}
                                        >
                                            {multiApplyMode ? 'Exit Multi-Select Mode' : 'Apply To Jobs For Me'}
                                        </Button>
                                    </div>
                                )}
                                {(crawlLoader || addingJob || (processingActive && processingMinimized)) && (
                                    <div style={{width: '100%'}}>
                                        <NoConnectionViewStyled>
                                            <div className="alert" >
                                                <OvalSpinner size={18} color="#3E8F93"/>
                                                <h2>{crawlLoader ? crawlMessage : addingJob ? addingJobMessage :  `Auto apply in progress ${processingCounts.done}/${processingCounts.total}`}</h2>
                                                {processingActive && processingMinimized && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginLeft: 8 }}>
                                                        <button onClick={handleProcessingStop} title="Stop" aria-label="Stop"
                                                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 34, height: 28, border: '1px solid crimson', color: 'crimson', background: 'transparent', borderRadius: '8px', cursor: 'pointer' }}>
                                                            <MdStopCircle />
                                                        </button>
                                                        <button onClick={() => setProcessingMinimized(false)} title="Maximize" aria-label="Maximize"
                                                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 34, height: 28, border: '1px solid #3E8F93', color: '#3E8F93', background: 'transparent', borderRadius: '8px', cursor: 'pointer' }}>
                                                            <MdOutlineOpenInFull />
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </NoConnectionViewStyled>
                                    </div>

                                )}
                                
                            </AssistSectionStyled>

                        </div>

                    </div>

                    {jobs.length === 0 &&
                        <NoConnectionViewStyled onClick={() => setAuthMenuOpen(false)}>
                            <h4>Optimize Resume to get Job Connections</h4>
                            <div style={{width: '250px', marginBottom: '1rem'}} ref={createResumeRef}>
                                <ButtonSubmitGreen onClick={goBackPrevPage}>Upload/Create Resume &nbsp;&nbsp;<FaLongArrowAltRight /></ButtonSubmitGreen>
                            </div>

                            {/* Show spinner + searching text when user has at least one resume */}
                            {(Array.isArray(allResumes) && allResumes.length > 0) ? (
                                <div className="alert" >
                                    <OvalSpinner size={18} color={'#3E8F93'} />
                                    <h2>Still searching for 80%+ Interview Chance Jobs</h2>
                                </div>
                            ) : (
                                <div className="alert" >
                                    <GoAlert color="#FFCD29"/>
                                    <h2>You have no job connections yet</h2>
                                </div>
                            )}

                            <div className="tipsContainer">
                                <div className="tip">
                                    <FiAlertCircle color="#5fbec5" />
                                    <h2>Tips to getting connected</h2>
                                </div>

                                <ol style={styles.list}>
                                    {Array.isArray(allResumes) && allResumes.length > 0 ? (
                                        <li>
                                            Click this button to manually get job connected:&nbsp;
                                            <ButtonThin onClick={crawlNewJobs} width={'140px'} height={'32px'} color={'#3E8F93'} border={'1px solid #3E8F93'}>
                                                Job-Connect Me
                                            </ButtonThin>
                                        </li>
                                    ) : (
                                        <li><b style={{color: '#3E8F93', textDecoration: 'underline', cursor: 'pointer'}} onClick={handleNavigateProfile}>Change job connect location</b>: 90%+ interview chance jobs might not be in your current connect location.</li>
                                    )}

                                    {!(isResumeSubbed && resumeSubDuration === 'Per Month') && (
                                        <li>
                                            <strong>Premium Month plan</strong> users get connected daily&nbsp;
                                            <ButtonThin onClick={() => setPricingOpened(true)} width={'100px'} height={'30px'} color={'#EE7B1C'} border={'1px solid #EE7B1C'}>
                                                Upgrade
                                            </ButtonThin>
                                        </li>
                                    )}

                                    <li>Do NOT combine several job positions (using OR, AND, /) in one resume e.g Business Developer/Sales Executive.</li>
                                </ol>
                            </div>

                        </NoConnectionViewStyled>
                    }

                    {showAutoApplyIntroModal && (
                        <MainModal isOpen={showAutoApplyIntroModal} onClose={() => setShowAutoApplyIntroModal(false)} width="740px">
                            {autoApplyModalView === 'intro' ? (
                                <div style={{ width: '100%', textAlign: 'center' }}>
                                    <h4 style={{ color: '#3E8F93', marginBottom: 12, textAlign: 'center' }}>How would you like me to Auto‑Apply?</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 10, justifyItems: 'center' }}>
                                        <Card sx={{ backgroundColor: 'transparent', borderRadius: '12px', border: '1px solid #c0d1d457', width: '100%' }}>
                                            <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                                <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: 6 }}>Set Auto‑Apply Schedule</div>
                                                {scheduleCardLoading ? (
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 40, marginBottom: 10 }}>
                                                        <OvalSpinner size={20} color="#3E8F93" />
                                                    </div>
                                                ) : existingSchedule ? (
                                                    <>  
                                                        <NoConnectionViewStyled>
                                                            <div className="alert">
                                                                <RiCalendarScheduleLine color="#FFCD29" fontSize="1.2rem"/>You have an existing auto-apply schedule
                                                            </div>
                                                        </NoConnectionViewStyled>
                                                        <div style={{ fontSize: '.9rem', marginBottom: 10, lineHeight: 1.4 }}>
                                                            <div><strong>Frequency:</strong> {existingSchedule.frequency}</div>
                                                            <div><strong>Time:</strong> {existingSchedule.timeOfDay}</div>
                                                            <div><strong>Max jobs/run:</strong> {existingSchedule.maxJobsPerRun}</div>
                                                            <div><strong>Country:</strong> {existingSchedule.country}</div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div style={{ fontSize: '.9rem', opacity: .9, marginBottom: 10 }}>
                                                        You will set a schedule for me to apply to jobs for you as you please, could be daily, weekly and at any time, and I will aggregate jobs, tailor application materials for each, search for the recruiter, apply automatically and send you feedback via email or in‑app in notifications and completed applications page.
                                                    </div>
                                                )}
                                                <div style={{ width: '100%', maxWidth: 260 }}>
                                                    {scheduleCtaLoading ? (
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 40 }}>
                                                            <OvalSpinner size={20} color="#3E8F93" />
                                                        </div>
                                                    ) : (
                                                        <Button
                                                            width="100%"
                                                            primary={true}
                                                            clickHandle={() => {
                                                                setScheduleCtaLoading(true);
                                                                setTimeout(() => {
                                                                    setAutoApplyModalView('schedule');
                                                                    setScheduleCtaLoading(false);
                                                                }, 300);
                                                            }}
                                                        >
                                                            {existingSchedule ? 'Edit Schedule' : 'Set Schedule'}
                                                        </Button>
                                                    )}
                                                </div>
                                                {existingSchedule && (
                                                    <div style={{ width: '100%', maxWidth: 260, marginTop: 8 }}>
                                                        <ButtonThin
                                                            border={'1px solid crimson'}
                                                            color={'crimson'}
                                                            width={'100%'}
                                                            height={'32px'}
                                                            onClick={async () => {
                                                                if (scheduleDeleteLoading) return;
                                                                try {
                                                                    await confirmDialog({
                                                                        title: 'Delete schedule?',
                                                                        description: 'This will remove your auto-apply schedule. You can set it up again later.',
                                                                        confirmationText: 'Delete',
                                                                        cancellationText: 'Cancel',
                                                                    });
                                                                } catch(_) {
                                                                    return; // user canceled
                                                                }
                                                                try {
                                                                    setScheduleDeleteLoading(true);
                                                                    await axios.delete('/user/auto-apply/schedule', { headers: { 'x-access-token': isAuth } });
                                                                    setExistingSchedule(null);
                                                                    successSetter('Schedule deleted');
                                                                } catch (e) {
                                                                    errorSetter('Failed to delete schedule');
                                                                } finally {
                                                                    setScheduleDeleteLoading(false);
                                                                }
                                                            }}
                                                        >
                                                            {scheduleDeleteLoading ? (
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                                                    <OvalSpinner size={16} color={'crimson'} />
                                                                </span>
                                                            ) : (
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                                                    <MdDeleteForever color={'crimson'} size={18} /> Delete Schedule
                                                                </span>
                                                            )}
                                                        </ButtonThin>
                                                    </div>
                                                )}
                                            </CardContent>
                                        </Card>
                                        <Card sx={{ backgroundColor: 'transparent', borderRadius: '12px', border: '1px solid #c0d1d457', width: '100%' }}>
                                            <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                                <div style={{ fontWeight: 700, fontSize: '1rem', marginBottom: 6 }}>Select Jobs to Auto Apply</div>
                                                <div style={{ fontSize: '.9rem', opacity: .9, marginBottom: 10 }}>
                                                    You will manually select jobs from your connection list, click start and then I will tailor application materials for each job and apply for you, all feedback will be sent also via email and in‑app in notifications and completed applications page.
                                                </div>
                                                <div style={{ width: '100%', maxWidth: 260 }}>
                                                    <Button
                                                        width="100%"
                                                        secondaryLight={true}
                                                        clickHandle={() => {
                                                            setShowAutoApplyIntroModal(false);
                                                            setMultiApplyMode(true);
                                                        }}
                                                    >
                                                        Select Jobs
                                                    </Button>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </div>
                                </div>
                            ) : (
                                <div style={{ width: '100%', textAlign: 'center', color: '#000', paddingTop: '120px' }}>
                                    <h3 style={{ color: '#3E8F93', marginBottom: 5 }}>Set Auto‑Apply Schedule</h3>
                                    <Alert sx={{padding: '0 5px', fontSize: '.8rem'}} severity="info">
                                        Choose when Bubble Ai should automatically apply to new jobs. We’ll tailor materials, find recruiters, apply and notify you of success or errors.
                                    </Alert>
                                    <ResumeSelectList
                                        label="Select Resume"
                                        labelStyle={{ color: '#000' }}
                                        resumes={allResumes}
                                        selectedIndex={activeResIndex}
                                        onSelectResume={(idx) => setActiveResIndex(idx + 1)}
                                        onPreviewResume={handleResumePreviewIntent}
                                    />

                                    {/* Country */}
                                    <div style={{ marginTop: 10, width: '100%'}}>
                                        <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 600 }}>Select Country</div>
                                        <InputHandler
                                            id="scheduleCountry"
                                            type="select"
                                            label="Country"
                                            name="country"
                                            value={scheduleCountry}
                                            onChange={(val) => setScheduleCountry(val)}
                                            required
                                        />
                                    </div>

                                    {/* Frequency */}
                                    <div style={{ marginTop: 10, width: '100%', color: '#000' }}>
                                        <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 600 }}>Frequency</div>
                                        <InputHandler
                                            id="scheduleFrequency"
                                            type="select"
                                            label="Type of Connection"
                                            name="frequency"
                                            value={scheduleFrequency}
                                            list={scheduleFrequencyOptions}
                                            onChange={(e) => setScheduleFrequency(e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Time of day */}
                                    <div style={{ marginTop: 10, width: '100%', color: '#000' }}>
                                        <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 600, color: '#000' }}>Time of day</div>
                                        <AuthInput
                                            id="scheduleTime"
                                            name="time"
                                            value={scheduleTime}
                                            label="HH:MM (24h)"
                                            inputType="time"
                                            inputGridSm={12}
                                            onChange={(e) => setScheduleTime(e.target.value)}
                                            required
                                        />
                                    </div>

                                    {/* Max jobs per run */}
                                    <div style={{ marginTop: 10, width: '100%', color: '#000' }}>
                                        <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 600, color: '#000' }}>Max jobs per run</div>
                                        <InputHandler
                                            id="scheduleMaxJobs"
                                            type="select"
                                            label="Max jobs per run"
                                            name="maxJobs"
                                            value={String(scheduleMaxJobs)}
                                            list={scheduleMaxJobsOptions}
                                            onChange={(e) => setScheduleMaxJobs(Number(e.target.value))}
                                            required
                                        />
                                    </div>

                                    {/* Enable Cold Introductions */}
                                    <div style={{ marginTop: 24, width: '100%', color: '#000', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={scheduleEnableColdIntro}
                                                    onChange={(e) => setScheduleEnableColdIntro(e.target.checked)}
                                                    sx={{
                                                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#3E8F93' },
                                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#3E8F93' },
                                                        '& .MuiSwitch-track': { backgroundColor: 'rgba(62,143,147,0.3)' }
                                                    }}
                                                />
                                            }
                                            label={<span style={{ fontWeight: 600, color: '#0C1E28' }}>Enable Cold Introductions</span>}
                                        />
                                        <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '4px', maxWidth: '400px', textAlign: 'center', lineHeight: '1.4' }}>
                                            If turned on, Bubble AI will actively search for and introduce you to matching companies directly to fulfill your schedule quota when there is a deficit in available posted jobs.
                                        </div>
                                    </div>

                                    {/* Actions */}
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginTop: 16, color: '#000' }}>
                                        <div style={{ maxWidth: 180, width: '100%' }}>
                                            <Button width="100%" secondaryLight={true} clickHandle={() => setAutoApplyModalView('intro')}>
                                                Back
                                            </Button>
                                        </div>
                                        <div style={{ maxWidth: 220, width: '100%' }}>
                                            {scheduleSaveLoading ? (
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 40 }}>
                                                    <OvalSpinner size={20} color="#3E8F93" />
                                                </div>
                                            ) : (
                                                <Button
                                                    width="100%"
                                                    primary={true}
                                                    clickHandle={async () => {
                                                    // Validate subscription
                                                    if (resumeSubDuration !== 'Per Month' || !isResumeSubbed) {
                                                        errorSetter('Scheduling is available on the Per Month plan. Please upgrade to continue.');
                                                        setPricingOpened(true);
                                                        return;
                                                    }

                                                    // Validate required fields
                                                    const idx = Number(activeResIndex) - 1;
                                                    const selected = (Array.isArray(allResumes) && idx >= 0) ? allResumes[idx] : null;
                                                    if (!selected) { errorSetter('Please select a resume'); return; }
                                                    if (!scheduleCountry) { errorSetter('Please select a country'); return; }
                                                    if (!scheduleFrequency) { errorSetter('Please select frequency'); return; }
                                                    if (!scheduleTime) { errorSetter('Please enter time of day'); return; }
                                                    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(String(scheduleTime))) { errorSetter('Time of day must be in HH:MM (24h) format'); return; }
                                                    if (!scheduleMaxJobs || Number(scheduleMaxJobs) < 1 || Number(scheduleMaxJobs) > 10) { errorSetter('Max jobs per run must be between 1 and 10'); return; }

                                                    try {
                                                        setScheduleSaveLoading(true);
                                                        const payload = {
                                                            resume: selected?.id || selected?.storageDetails?.name,
                                                            country: scheduleCountry,
                                                            frequency: scheduleFrequency,
                                                            time: scheduleTime,
                                                            maxJobs: Number(scheduleMaxJobs),
                                                            enableColdIntroductions: scheduleEnableColdIntro
                                                        };
                                                        const resp = await axios.post('/user/auto-apply/schedule', payload, { headers: { 'x-access-token': isAuth } });
                                                        if (resp?.data?.success) {
                                                            successSetter('Schedule saved');
                                                            // Cache locally for future intro view without refetch
                                                            try {
                                                                setExistingSchedule({
                                                                    id: resp?.data?.schedule?.id || (existingSchedule?.id || 'local'),
                                                                    resumeRef: String(selected?.id || selected?.storageDetails?.name || ''),
                                                                    country: scheduleCountry,
                                                                    frequency: scheduleFrequency,
                                                                    timeOfDay: scheduleTime,
                                                                    maxJobsPerRun: Number(scheduleMaxJobs),
                                                                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
                                                                    enableColdIntroductions: scheduleEnableColdIntro,
                                                                    active: true
                                                                });
                                                            } catch(_){}
                                                            setShowAutoApplyIntroModal(false);
                                                            // If Gmail not connected, prompt immediately to complete setup
                                                            if (!gmailGranted) {
                                                                try {
                                                                    const r = await axios.get('/user/gmail/permission-status', { headers: { 'x-access-token': isAuth }});
                                                                    const { isGmail, granted } = r?.data || {};
                                                                    setEmailProvider(isGmail ? 'gmail' : 'other');
                                                                    if (isGmail && !granted) {
                                                                        try {
                                                                            const s = await axios.get('/user/gmail/oauth/start?mode=popup', { headers: { 'x-access-token': isAuth }});
                                                                            if (s?.data?.authUrl) setGmailAuthUrl(s.data.authUrl);
                                                                        } catch(_){}
                                                                        // Mark this Gmail flow as schedule so we don't auto-start multi-apply
                                                                        setGmailFlow('schedule');
                                                                        try { sessionStorage.setItem('gmailFlow', 'schedule'); } catch(_) {}
                                                                        setShowEmailPermModal(true);
                                                                    }
                                                                } catch(_){}
                                                            }
                                                        } else if (resp?.data?.status === 'quota' && resp?.data?.openPricing) {
                                                            errorSetter(resp?.data?.message || 'Upgrade required to save schedule.');
                                                            setPricingOpened(true);
                                                        } else {
                                                            errorSetter('Failed to save schedule');
                                                        }
                                                    } catch (e) {
                                                        const resp = e?.response;
                                                        if (resp && resp.data && resp.data.status === 'quota') {
                                                            errorSetter(resp.data.message || 'Upgrade required to save schedule.');
                                                            if (resp.data.openPricing) setPricingOpened(true);
                                                            return;
                                                        }
                                                        errorSetter(resp?.data?.error || 'Failed to save schedule');
                                                    } finally {
                                                        setScheduleSaveLoading(false);
                                                    }
                                                }}
                                                >
                                                    Save Schedule
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </MainModal>
                    )}

                    {jobs.length > 0 &&
                        <JobConnection
                            data={jobs}
                            handleCopy={handleCopy}
                            getJob={getJob}
                            getResume={getResume}
                            chooseActStr={chooseActStr}
                            deleteJob={deleteJob}
                            jobListRef={jobListRef}
                            loadingJobs={loadingJobs}
                            multiApplyMode={multiApplyMode}
                            selectedJobIds={selectedJobIds}
                            onToggleJobSelect={handleToggleJobSelect}
                            maxSelectable={5}
                            onStart={handleStartMultiApply}
                            startPending={startPending}
                            gmailGranted={gmailGranted}
                            gmailIsGmail={gmailIsGmail}
                            onDisconnectGmail={handleDisconnectGmail}
                            disconnectPending={disconnectPending}
                            processingView={processingActive && !processingMinimized ? (
                                <ProcessingQueueView
                                    jobs={processingJobs}
                                    counts={processingCounts}
                                    perJobStatuses={perJobStatuses}
                                    perJobStages={perJobStages}
                                    stopPending={stopPending}
                                    onClose={handleProcessingClose}
                                    onStop={handleProcessingStop}
                                />
                            ) : null}
                        />
                    }


                    <ResumePreviewModal
                        open={previewModalOpen}
                        resume={previewResume}
                        onClose={closeResumePreview}
                        zIndex={1200000}
                    />

                    {resumeSelectorModalOpen && (
                        <ResumeSelectorModal
                            closeModalsAndReset={closeModalsAndReset}
                            allResumes={allResumes}
                            activeResIndex={activeResIndex}
                            handleResumeSelect={handleResumeSelect}
                            handleResumePreview={handleResumePreviewIntent}
                            actionString={actionString}
                            handleGenerate={handleGenerate}
                        />
                    )}

                        {showApplyAfterAddModal && addedJobForApply && (
                            <MainModal isOpen={showApplyAfterAddModal} onClose={() => { setShowApplyAfterAddModal(false); setAddedJobForApply(null); }} width="640px">
                                <div style={{ textAlign: 'center', padding: '20px' }}>
                                    <h3 style={{ color: '#3E8F93', marginBottom: 8 }}>Apply for this job?</h3>
                                    <div style={{ marginBottom: 14, fontSize: '.95rem' }}>
                                        I added the job <strong>{addedJobForApply.job_title || addedJobForApply.title || ''}</strong> at <strong>{addedJobForApply.company_name || addedJobForApply.company || ''}</strong>. Would you like me to apply automatically for you?
                                    </div>
                                    <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                                        <div style={{ minWidth: 160 }}>
                                            <ButtonSubmitGreen onClick={() => {
                                                try {
                                                    const ident = getJobIdentifier(addedJobForApply);
                                                    setShowApplyAfterAddModal(false);
                                                    setAddedJobForApply(null);
                                                    if (!ident) { errorSetter('Could not resolve job to apply.'); return; }
                                                    // start processing selecting only the newly added job
                                                    startProcessingWithSelected([ident]);
                                                } catch (e) {
                                                    setShowApplyAfterAddModal(false);
                                                    setAddedJobForApply(null);
                                                    errorSetter('Failed to start auto-apply.');
                                                }
                                            }}>
                                                Apply for Me
                                            </ButtonSubmitGreen>
                                        </div>
                                        <div style={{ minWidth: 140 }}>
                                            <Button width="100%" secondaryLight={true} clickHandle={() => { setShowApplyAfterAddModal(false); setAddedJobForApply(null); }}>
                                                No, Thanks
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </MainModal>
                        )}
                    {showInternalAppJobModal && (
                        <InternalAppJobModal
                            closeModalsAndReset={closeModalsAndReset}
                            setShowInternalAppJobModal={setShowInternalAppJobModal}
                            linkedinUrl={linkedinUrl}
                            companyUrl={companyUrl}
                            applicants={applicants}
                            allResumes={allResumes}
                            activeResIndex={activeResIndex}
                            handleResumeSelect={handleResumeSelect}
                            handleResumePreview={handleResumePreviewIntent}
                            handleInternalJobModalSubmit={handleInternalJobModalSubmit}
                            handleApplicationLinkCopy={handleApplicationLinkCopy}
                        />
                    )}
                    {showAddJobModal && (
                        <PlainModalOverlay>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <div className='prev-page' onClick={() => { setShowAddJobModal(false); setAddJobUrl(''); setAddJobCompany(''); }}>
                                    <FaLongArrowAltLeft />
                                </div>
                                <h4 style={{ color: '#3E8F93', marginBottom: 10 }}>Add a Job from Any Site</h4>
                                <Alert sx={{padding: '0 5px', fontSize: '.75rem', marginBottom: 2}} severity="info">
                                    Find a job you need assistance applying to? Paste the full job posting link. I'll fetch & add it to your job connections where you can Auto-Apply.
                                </Alert>
                                <AuthInput
                                    id="addJobUrl"
                                    name="addJobUrl"
                                    value={addJobUrl}
                                    label="Paste job URL here..."
                                    inputType="text"
                                    inputGridSm={12}
                                    onChange={(e) => setAddJobUrl(e.target.value)}
                                    required
                                    mb={2}
                                />
                                <AuthInput
                                    id="addJobCompany"
                                    name="addJobCompany"
                                    value={addJobCompany}
                                    label="Company name (improves matching)"
                                    inputType="text"
                                    inputGridSm={12}
                                    required
                                    onChange={(e) => setAddJobCompany(e.target.value)}
                                    mb={2}
                                />
                                <div style={{ width: '100%', marginTop: 20 }}>
                                    <ButtonSubmitGreen onClick={async () => {
                                        if (!addJobUrl.trim()) { errorSetter('Provide a job URL'); return; }
                                        if (!addJobCompany.trim()) { errorSetter('Provide a company name'); return; }
                                        let normalized = addJobUrl.trim();
                                        if (!/^https?:\/\//i.test(normalized)) normalized = 'https://' + normalized;
                                        try { new URL(normalized); } catch { errorSetter('Invalid URL'); return; }
                                        // Close modal & show loader immediately (optimistic)
                                        setShowAddJobModal(false);
                                        setAddingJob(true);
                                        setAddingJobMessage('Queuing job...');
                                        setProgressPercentage(1);
                                        setProgressStatus('Queued');
                                        // store normalized URL for robust SSE matching
                                        lastAddUrlRef.current = normalizeUrlForMatch(normalized);
                                        // Clear any previous timer
                                        if (addJobTimeoutRef.current) { clearTimeout(addJobTimeoutRef.current); }
                                        // Safety timeout (~7 minutes to accommodate scraping)
                                        addJobTimeoutRef.current = setTimeout(() => {
                                            if (pendingAddRef.current) {
                                                errorSetter('Timed out adding job');
                                                setAddingJob(false);
                                                setProgressStatus('Timed out');
                                                pendingAddRef.current = null;
                                            }
                                        }, 420000);
                                        try {
                                            const res = await axios.post('/user/add-external-job', { url: normalized, companyName: addJobCompany || undefined }, { headers: { 'x-access-token': isAuth } });
                                            if (res.data.status === 'exists') {
                                                if (addJobTimeoutRef.current) { clearTimeout(addJobTimeoutRef.current); addJobTimeoutRef.current = null; }
                                                setAddingJob(false);
                                                successSetter('Job already in your list');
                                                return;
                                            }
                                            if (res.data.status === 'already_queued' && res.data.requestId) {
                                                pendingAddRef.current = res.data.requestId;
                                                infoSetter('Job already queued. Fetching details...');
                                                setAddingJobMessage('Fetching job details (this may take ~60-120s)');
                                                return;
                                            }
                                            if (res.data.status === 'queued' && res.data.requestId) {
                                                pendingAddRef.current = res.data.requestId;
                                            }
                                            infoSetter('Job queued. Fetching details...');
                                            setAddingJobMessage('Fetching job details (this may take ~60-120s)');
                                        } catch (e) {
                                            if (addJobTimeoutRef.current) { clearTimeout(addJobTimeoutRef.current); addJobTimeoutRef.current = null; }
                                            setAddingJob(false);
                                            errorSetter(e?.response?.data?.message || 'Failed to queue job');
                                        }
                                    }} style={{ width: '100%', background: '#3E8F93' }}>
                                        Add Job
                                    </ButtonSubmitGreen>
                                </div>
                            </div>
                        </PlainModalOverlay>
                    )}
                    {showCrawlModal && (
                        <PlainModalOverlay>
                            <div style={{ width: '100%', textAlign: 'center', paddingLeft: 0 }}>
                                <div className='prev-page' onClick={() => setShowCrawlModal(false)}>
                                    <FaLongArrowAltLeft />
                                </div>
                                <h4 style={{ color: '#3E8F93', marginBottom: 10 }}>Get New Job Connects</h4>
                                <Alert sx={{padding: '0 5px', fontSize: '.8rem', marginBottom: 2}} severity="info">Bubble Ai will search for new relevant job connections based on the selected resume and location. We'll notify you via email when matches are found.</Alert>

                                <ResumeSelectList
                                    label="Select Resume"
                                    resumes={allResumes}
                                    selectedIndex={activeResIndex}
                                    onSelectResume={(idx) => handleResumeSelect(idx)}
                                    onPreviewResume={handleResumePreviewIntent}
                                />

                                <div style={{ marginTop: 10, width: '100%' }}>
                                    <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 600, display: 'inline-block', paddingLeft: 0, marginLeft: 0 }}>Select Country</div>
                                    <AuthInput
                                        id="crawlCountry"
                                        value={crawlCountry}
                                        inputType="country-select"
                                        inputGridSm={12}
                                        onChange={(val) => setCrawlCountry(val)}
                                        required
                                    />
                                </div>

                                <div style={{ marginTop: 10, width: '100%' }}>
                                    <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 600, display: 'inline-block', paddingLeft: 0, marginLeft: 0 }}>Select State / Region</div>
                                    <AuthInput
                                        country={crawlCountry}
                                        id="crawlState"
                                        name={crawlState}
                                        value={crawlState}
                                        inputType="state-select"
                                        inputGridSm={12}
                                        onChange={(val) => setCrawlState(val)}
                                        required
                                    />
                                </div>

                                <div style={{ marginTop: 10, width: '100%' }}>
                                    <div style={{ marginBottom: '10px', textAlign: 'center', fontWeight: 600, display: 'inline-block', paddingLeft: 0, marginLeft: 0 }}>Type of Job Connection</div>
                                    <AuthInput
                                        id="crawlJobConnectType"
                                        value={crawlJobConnectType}
                                        inputType="select2"
                                        inputGridSm={12}
                                        list={jobTypesArray}
                                        onChange={(e) => setCrawlJobConnectType(e.target.value)}
                                        required
                                    />
                                </div>

                                <div style={{ width: '100%', marginTop: 20 }}>
                                    <ButtonSubmitGreen onClick={fetchNewJobConnects} style={{ width: '100%', background: '#3E8F93' }}>
                                        Search For New Connects
                                    </ButtonSubmitGreen>
                                </div>
                            </div>
                        </PlainModalOverlay>
                    )}
                    {showEmailPermModal && (
                        <PlainModalOverlay>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <div className='prev-page' onClick={() => setShowEmailPermModal(false)}>
                                    <FaLongArrowAltLeft />
                                </div>
                                <h4 style={{ color: '#3E8F93', marginBottom: 10 }}>Allow Bubble Ai to send emails on your behalf</h4>
                                <Alert sx={{padding: '0 5px', fontSize: '.8rem', marginBottom: 2}} severity="info">
                                    We'll send follow-up or application emails from your Gmail account only when you start Auto-Apply. You can revoke access anytime from your Google account.
                                </Alert>
                                {emailProvider !== 'gmail' && (
                                    <Alert sx={{padding: '5px', fontSize: '.8rem', marginBottom: 12, color: '#FFA000'}} severity="warning">
                                        Your account email is not a Gmail address. Email sending will be done from Bubble Ai's internal sender which might be less effective.
                                    </Alert>
                                )}
                                <div style={{ display:'flex', alignItems:'center', justifyContent:'center', marginTop: 8 }}>
                                    <SiGmail color="#EA4335" size={28} />
                                </div>
                                <div style={{ width: '100%', marginTop: 20 }}>
                                    {emailProvider === 'gmail' ? (
                                        <>
                                            <ButtonSubmitGreen 
                                                onClick={() => {
                                                    if (gmailAuthUrl) {
                                                        try {
                                                            // Persist selection to resume after OAuth
                                                            sessionStorage.setItem('multiApplySelected', JSON.stringify(selectedJobIds || []));
                                                            sessionStorage.setItem('resumeAfterGmail', '1');
                                                            // Persist flow for redirect-based completion
                                                            sessionStorage.setItem('gmailFlow', gmailFlow || 'multi');
                                                        } catch(_) {}
                                                        // Prefer popup to avoid reloading the app
                                                        const w = 520, h = 640;
                                                        const y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
                                                        const x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
                                                        const popupUrl = gmailAuthUrl;
                                                        const win = window.open(popupUrl, 'gmail-oauth', `width=${w},height=${h},left=${x},top=${y},resizable=yes,scrollbars=yes,status=yes`);
                                                        gmailPopupRef.current = win;
                                                        // Fallback to same-tab if popup blocked
                                                        if (!win || win.closed || typeof win.closed === 'undefined') {
                                                            window.location.href = popupUrl;
                                                            return;
                                                        }
                                                        const handler = (ev) => {
                                                            try {
                                                                if (ev && ev.data && ev.data.type === 'gmail_connected') {
                                                                    window.removeEventListener('message', handler);
                                                                    try { if (gmailPopupCheckRef.current) { clearInterval(gmailPopupCheckRef.current); gmailPopupCheckRef.current = null; } } catch(_) {}
                                                                    gmailPopupRef.current = null;
                                                                    setShowEmailPermModal(false);
                                                                    // Resume if user intended to continue
                                                                    try {
                                                                        const raw = sessionStorage.getItem('multiApplySelected');
                                                                        const ids = raw ? JSON.parse(raw) : [];
                                                                        sessionStorage.removeItem('resumeAfterGmail');
                                                                        sessionStorage.removeItem('multiApplySelected');
                                                                        setGmailGranted(true);
                                                                        setGmailIsGmail(true);
                                                                        if (gmailFlow === 'multi' && Array.isArray(ids) && ids.length) {
                                                                            startProcessingWithSelected(ids);
                                                                        } else {
                                                                            successSetter('Gmail connected');
                                                                        }
                                                                    } catch(_) {}
                                                                }
                                                            } catch(_){}
                                                        };
                                                        window.addEventListener('message', handler);
                                                        // Poll as a fallback in case postMessage fails due to origin mismatch
                                                        try {
                                                            if (gmailPopupCheckRef.current) { clearInterval(gmailPopupCheckRef.current); }
                                                            gmailPopupCheckRef.current = setInterval(async () => {
                                                                try {
                                                                    if (!gmailPopupRef.current || gmailPopupRef.current.closed) {
                                                                        clearInterval(gmailPopupCheckRef.current);
                                                                        gmailPopupCheckRef.current = null;
                                                                        const r = await axios.get('/user/gmail/permission-status', { headers: { 'x-access-token': isAuth }});
                                                                        const granted = !!r?.data?.granted;
                                                                        if (granted) {
                                                                            setGmailGranted(true);
                                                                            setGmailIsGmail(!!r?.data?.isGmail);
                                                                            setShowEmailPermModal(false);
                                                                            try {
                                                                                const raw = sessionStorage.getItem('multiApplySelected');
                                                                                const ids = raw ? JSON.parse(raw) : [];
                                                                                sessionStorage.removeItem('resumeAfterGmail');
                                                                                sessionStorage.removeItem('multiApplySelected');
                                                                                if (gmailFlow === 'multi' && Array.isArray(ids) && ids.length) {
                                                                                    startProcessingWithSelected(ids);
                                                                                } else {
                                                                                    successSetter('Gmail connected');
                                                                                }
                                                                            } catch(_){ }
                                                                        }
                                                                    }
                                                                } catch(_){ /* ignore poll errors */ }
                                                            }, 800);
                                                        } catch(_){ }
                                                    } else {
                                                        errorSetter('Unable to start Gmail connection. Try again.');
                                                    }
                                                }} 
                                                style={{ width: '100%', background: '#3E8F93' }}>
                                                    Connect Gmail and Continue
                                            </ButtonSubmitGreen>
                                            <div style={{ height: 10 }} />

                                            <Alert sx={{padding: '5px', fontSize: '.8rem', marginBottom: 12}} severity="warning">
                                                Optionally proceed without connecting your Gmail BUT sending will be done from Bubble Ai's internal sender which might be less effective.
                                            </Alert>
                                            <div style={{marginTop: '-80px'}}>
                                                <Button
                                                    width="100%"
                                                    secondaryLight={true}
                                                    clickHandle={handleContinueWithoutGmail}
                                                >
                                                    Continue Without
                                                </Button>
                                            </div>

                                        </>
                                    ) : (
                                        <>
                                            <Button
                                                width="100%"
                                                secondaryLight={true}
                                                clickHandle={handleContinueWithoutGmail}
                                            >
                                                Continue Without
                                            </Button>
                                        </>

                                    )}
                                </div>
                            </div>
                        </PlainModalOverlay>
                    )}
                    {showFieldAnswersModal && (
                        <FieldAnswersModal
                            closeModalsAndReset={closeModalsAndReset}
                            fieldAnswers={fieldAnswers}
                            fieldAnswersUrl={fieldAnswersUrl}
                            handleCopy={handleCopy}
                            handleGetResumeDirect={handleGetResumeDirect}
                            handleGetCoverLetterDirect={handleGetCoverLetterDirect}
                            handleCompanySiteAutoApply={handleCompanySiteAutoApply}
                            loginQnAInput={loginQnAInput}
                            handleLoginQnAInputChange={handleLoginQnAInputChange}
                            handleLoginQnASubmit={handleLoginQnASubmit}
                            loginQnALoading={loginQnALoading}
                        />
                    )}
                    {showQnAModal && (
                        <QnAModal
                            closeModalsAndReset={closeModalsAndReset}
                            // removed legacy externalJobUrl prop
                            linkedinUrl={linkedinUrl}
                            loginQnAJobDesc={loginQnAJobDesc}
                            handleLoginQnAJobDescChange={e => setLoginQnAJobDesc(e.target.value)}
                            loginQnAJobDescSaved={loginQnAJobDescSaved}
                            setLoginQnAJobDescSaved={setLoginQnAJobDescSaved}
                            loginQnAEditingDesc={loginQnAEditingDesc}
                            setLoginQnAEditingDesc={setLoginQnAEditingDesc}
                            loginQnAInput={loginQnAInput}
                            handleLoginQnAInputChange={handleLoginQnAInputChange}
                            loginQnAList={loginQnAList}
                            handleLoginQnASubmit={handleLoginQnASubmit}
                            loginQnALoading={loginQnALoading}
                            handleCopy={handleCopy}
                            handleGetResumeDirect={handleGetResumeDirect}
                            handleGetCoverLetterDirect={handleGetCoverLetterDirect}
                        />
                    )}
                    {successfulAchievement &&
                        <SuccessFailureModal
                            success={successfulAchievement}
                            successText="Congratulations, You have been rewarded!"
                            bodyText="You gained Bubble Points! Keep creating resumes and applying to jobs to earn a free sub on us."
                            buttonText="Claim Points Reward"
                            fullName={user.firstName}
                        />
                    }

                    {loading && (
                        <Modal
                            header4={"Do not close or Reload"}
                            header3={progressStatus}
                            progress={progressPercentage}
                        />
                    )}
                </div>
            )}
            {/* Tutorial popovers */}
            <TutorialPopover
                show={currentTip === 1 && !sequenceCompleted && !anyOverlayOpen}
                tipId={JOBHUB_TIP_ID}
                anchorRef={applyForMeRef}
                title={'Let me apply for you'}
                description={'Set a schedule to have Bubble Ai tailor materials and apply to jobs automatically, you do not have to do anything else.'}
                primaryLabel={'Try Auto‑Apply'}
                onClose={() => { setCurrentTip(0); scheduleNextTip(1); }}
                onPrimary={() => { handlePrimaryApplyClick(); }}
            />

            <TutorialPopover
                show={currentTip === 2 && !sequenceCompleted && !anyOverlayOpen}
                tipId={JOBHUB_TIP_ID}
                anchorRef={
                    // if user has no resume anchor to createResumeRef else anchor to jobConnectRef
                    (Array.isArray(allResumes) && allResumes.length > 0) ? jobConnectRef : createResumeRef
                }
                title={(Array.isArray(allResumes) && allResumes.length > 0) ? 'Get job matches instantly' : 'Create or upload old resume'}
                description={(Array.isArray(allResumes) && allResumes.length > 0) ? 'Click "Job‑Connect Me" and Bubble Ai will search for 90%+ interview chance jobs.' : 'Click here to create or upload a resume so Bubble Ai can start applying to jobs for you.'}
                primaryLabel={'Try it'}
                onClose={() => { setCurrentTip(0); scheduleNextTip(2); }}
                onPrimary={() => { if (Array.isArray(allResumes) && allResumes.length > 0) { crawlNewJobs(); } else { goBackPrevPage(); } }}
            />

            <TutorialPopover
                show={currentTip === 3 && !sequenceCompleted && !anyOverlayOpen}
                tipId={JOBHUB_TIP_ID}
                anchorRef={viewAppsRef}
                title={'View your applications'}
                description={'Open the Applications view to see jobs Bubble Ai applied to. Monitor successful or failed attempts here.'}
                primaryLabel={'Open Applications'}
                onClose={() => { setCurrentTip(0); scheduleNextTip(3); }}
                onPrimary={() => { navigate('/user/dashboard/auto-apply'); }}
            />

            <TutorialPopover
                show={currentTip === 4 && !sequenceCompleted && !anyOverlayOpen}
                tipId={JOBHUB_TIP_ID}
                anchorRef={changeLocationRef}
                title={'Change your connect location'}
                description={'Update your job connect location so Bubble Ai searches in the right region for best matches + better chances.'}
                primaryLabel={'Change Location'}
                onClose={() => { setCurrentTip(0); scheduleNextTip(4); }}
                onPrimary={() => { handleNavigateProfile(); }}
            />

            <TutorialPopover
                show={currentTip === 5 && !sequenceCompleted && !anyOverlayOpen}
                tipId={JOBHUB_TIP_ID}
                anchorRef={addExternalRef}
                title={'Add an external job'}
                description={'Paste a job posting link from any site to add it to your connections for Auto‑Apply and more.'}
                primaryLabel={'Add Job'}
                onClose={() => { setCurrentTip(0); scheduleNextTip(5); }}
                onPrimary={() => { setShowAddJobModal(true); }}
            />

            <TutorialPopover
                show={currentTip === 6 && !sequenceCompleted && !anyOverlayOpen}
                tipId={JOBHUB_TIP_ID}
                anchorRef={{ current: document.querySelector('.auth-header .showOptions') || null }}
                title={'More options'}
                description={'Open the menu to access settings and additional career tools. Use the bell for notifications, and the moon circle to toggle light or dark theme.'}
                primaryLabel={'Open Menu'}
                onClose={() => { setCurrentTip(0); setSequenceCompleted(true); }}
                onPrimary={() => { toggleMenu(); setSequenceCompleted(true); }}
            />

        </div>
    );

    
};

export default React.memo(JobHub);

